import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { Group } from 'src/app/common-class/pages';
import { PreviewData } from 'src/app/common-class/survey';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
declare let $: any;

@Component({
  selector: 'app-rating-scale',
  templateUrl: './rating-scale.component.html',
  styleUrls: ['./rating-scale.component.css'],
})
export class RatingScaleComponent implements OnInit, OnChanges {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() group: Group;
  @Input() isDisplaySubQno: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  isNA: boolean;
  smileyClass: any = [
    'very-sad-smiley',
    'sad-smiley',
    'neutral-smiley',
    'happy-smiley',
    'very-happy-smiley',
  ];
  isRTL: boolean = false;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isRTLScale: boolean;
  isReverseScale: boolean;
  sliderMinValue: number;
  sliderMaxValue: number;
  isNaScale: boolean;
  clearText: string;
  isShowClear: boolean;
  surveyFormat: number;
  isNewParticipation: boolean;
  newParticipationBtnText: string;
  showNewParticipationButton: any;
  isAriaRequired: boolean;
  isAnsChange: boolean;
  resetPageSub: any;
  isMobileRatingScale: boolean = false;
  ansSort: Answers[] = [];
  preview: PreviewData;
  isEditPostPop: boolean = false;

  setPreviewData(preview: PreviewData) {
    this.preview = preview;
  }

  ngOnChanges(changes: SimpleChanges) {
    let curVal;
    let preVal;
    let change = changes['JsonData'];

    if (change) {
      curVal = JSON.stringify(change.currentValue);
      preVal = JSON.stringify(change.previousValue);
    }

    if (this.isMobile) {
      this.questions = JSON.parse(this.JsonData);
    }

    if (curVal != preVal && preVal != undefined) {
      if (
        (this.questions.RS_Type == 2 && this.questions.RSFormat == 3) ||
        (this.questions.RS_Type == 3 && this.questions.RSFormat == 2) ||
        (this.questions.RS_Type == 4 && this.questions.RSFormat == 2)
      ) {
        this.questions = JSON.parse(this.JsonData);
      }
    }
  }

  constructor(private service: ParticipationDataService) {}

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
    }
    this.isEditPostPop = this.service.getisEditPostPop();
    if (this.questions.isNA) {
      this.isNA = true;
    }
    if (this.questions.population_type == 3) {
      this.isAnsChange = true;
    }
    this.isRTL = this.service.getRTL();

    this.setSliderMinMaxValue();
    if (
      !(
        this.questions.RS_Type == 3 ||
        this.questions.RS_Type == 4 ||
        this.questions.RS_Type == 2 ||
        (this.questions.RS_Type == 0 && this.questions.RSFormat == 2)
      )
    ) {
      // Display Scale from Desc Order if Reverse OR (RTL but not reverse)
      if (
        (this.isRTL && !this.questions.isAnchorReverse) ||
        (this.questions.isAnchorReverse && !this.isRTL)
      ) {
        this.questions.Answers.sort((n1, n2) => n2.weight - n1.weight);

        if (this.questions.RS_Type === 1 && this.isMobile) {
          if (this.questions.Answers.length == 3) {
            this.smileyClass = ['very-happy-smiley', 'neutral-smiley', 'very-sad-smiley'];
          } else if (this.questions.Answers.length == 5) {
            this.smileyClass = [
              'very-happy-smiley',
              'happy-smiley',
              'neutral-smiley',
              'sad-smiley',
              'very-sad-smiley',
            ];
          }
        }
      } else if (this.questions.RS_Type === 1 && this.isMobile) {
        if (this.questions.Answers.length == 3) {
          this.smileyClass = ['very-sad-smiley', 'neutral-smiley', 'very-happy-smiley'];
        } else if (this.questions.Answers.length == 5) {
          this.smileyClass = [
            'very-sad-smiley',
            'sad-smiley',
            'neutral-smiley',
            'happy-smiley',
            'very-happy-smiley',
          ];
        }
      }
    }

    if (this.isMobile && this.questions.RSFormat == 0 && this.isRTL) {
      for (const answer of this.questions.Answers) {
        this.ansSort.push(answer);
      }

      if (this.isRTL && !this.questions.isAnchorReverse) {
        this.ansSort.sort((n1, n2) => n1.weight - n2.weight);
      } else {
        this.ansSort.sort((n1, n2) => n2.weight - n1.weight);
      }
    }

    if (
      this.questions.RS_Type == 3 ||
      this.questions.RS_Type == 4 ||
      (this.questions.RS_Type == 0 && this.questions.RSFormat == 2)
    ) {
      if (
        (this.questions.isAnchorReverse && this.questions.RSFormat != 1) ||
        (this.questions.RSFormat == 1 &&
          ((this.isRTL && !this.questions.isAnchorReverse) ||
            (this.questions.isAnchorReverse && !this.isRTL)))
      ) {
        this.questions.Answers.sort((n1, n2) => n2.weight - n1.weight);
      }

      if (
        this.questions.RS_Type == 0 &&
        this.questions.RSFormat == 2 &&
        this.questions.isAnchorReverse &&
        !this.isRTL
      ) {
        this.questions.Answers.sort((n1, n2) => n2.weight - n1.weight);
      }
      if (this.questions.RS_Type == 3) {
        if (
          (this.isRTL && !this.questions.isAnchorReverse) ||
          (this.questions.isAnchorReverse && !this.isRTL)
        ) {
          this.smileyClass = [
            'very-happy-smiley',
            'happy-smiley',
            'smile-smiley',
            'neutral-smiley',
            'unhappy-smiley',
            'sad-smiley',
            'very-sad-smiley',
          ];
        } else {
          this.smileyClass = [
            'very-sad-smiley',
            'sad-smiley',
            'unhappy-smiley',
            'neutral-smiley',
            'smile-smiley',
            'happy-smiley',
            'very-happy-smiley',
          ];
        }
      }
      if (this.questions.RS_Type == 4) {
        if (
          (this.isRTL && !this.questions.isAnchorReverse) ||
          (this.questions.isAnchorReverse && !this.isRTL)
        ) {
          this.smileyClass = [
            'very-happy-smiley',
            'happy-smiley',
            'neutral-smiley',
            'sad-smiley',
            'very-sad-smiley',
          ];
        } else {
          this.smileyClass = [
            'very-sad-smiley',
            'sad-smiley',
            'neutral-smiley',
            'happy-smiley',
            'very-happy-smiley',
          ];
        }
      }
    }

    if (this.questions.RS_Type == 2 && this.questions.RSFormat == 1) {
      if (this.isRTL && !this.questions.isAnchorReverse) {
        this.questions.Answers.sort((n1, n2) => n2.weight - n1.weight);
      }
      this.smileyClass = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
    }
    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    this.clearText = this.service.getSurveyMessages().Clear;
    this.isShowClear = this.questions.IsShowClearOption && this.questions.population_type != 3;

    this.surveyFormat = this.service.surveyFormat;
    this.isNewParticipation = this.service.isNewParticipation;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton =
      this.isNewParticipationButton &&
      (!this.service.isAutoScroll || this.questions.population_type == 3);
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
    }
    setTimeout(() => {
      this.initializeSliders();
    }, 100);
  }

  private initializeSliders(): void {
    let self = this;
    let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_RS';

    if (!this.isMobile) {
      // Normal Rating Slider
      $('#' + id).slider({
        value: null,
        step: 1,
        range: 'min',
        slide: function (event, ui) {
          let selectedVal = Math.abs(ui.value) - 1;
          $(event.target)
            .closest('.rs-wrapper')
            .find($("input[weight='" + selectedVal + "']"))
            .prop('checked', true);
          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text')
            .removeClass('show-rs-val');
          $(event.target)
            .closest('.rs-wrapper')
            .find($("label[weight='" + (selectedVal + 1) + "']"))
            .closest('.rs-slider-axis-val')
            .find('.slider-value-text')
            .addClass('show-rs-val');
          let labelValue = parseInt(
            $(event.target)
              .closest('.rs-wrapper')
              .find($("label[weight='" + (selectedVal + 1) + "']"))
              .closest('.rs-slider-axis-val')
              .text(),
          );
          $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val(labelValue);
          $(event.target).removeClass('inactive-scale');
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text')
            .removeClass('disabled');
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text-cont')
            .removeClass('disabled1');

          // ADA
          self.setRuntimeADAProperties(event.target, selectedVal + 1);

          $(event.target).find('.slider-value-text').removeClass('tooltip-info');

          let labelCount = $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val');
          if (labelCount.length % 2 == 0) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.45 + 'px');
          } else {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.3 + 'px');
          }

          if (
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val span')
              .text() != ''
          ) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val')
              .addClass('tooltip-info');
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val.tooltip-info')
              .css(
                'width',
                $(event.target).find('.slider-value-text.show-rs-val.tooltip-info span').text()
                  .length *
                  10 +
                  10 +
                  'px',
              );
          }

          $(event.target).closest('.rs-wrapper').find('.slider-value-text.rs-top-val').show();
        },
        create: function (event) {
          let scaleWidth: number;
          let sliderValTextHeight: number[] = [];
          let bottomSliderValTextHeight: number[] = [];

          $(event.target).closest('.rs-wrapper').css('opacity', '0');
          self.isReverseScale =
            $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isrev') ==
            'true';
          self.isRTLScale = $(event.target).parents().hasClass('RTLDir');
          self.isNaScale = $(event.target).closest('.rs-wrapper').find('.na-checkbox').length > 0;

          let minValue = parseInt(
            $(event.target)
              .parents('.answer-option-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .first()
              .attr('weight')
              .trim(),
          );
          let maxValue = 0;

          // Set Max Value
          if (self.isNaScale) {
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .eq(-2)
                .attr('weight')
                .trim(),
            );
          } else {
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
          }

          // Set Scale Min/Max Value
          if (
            (self.isRTLScale && !self.isReverseScale) ||
            (!self.isRTLScale && self.isReverseScale)
          ) {
            $(event.target).slider('option', 'min', -minValue);
            $(event.target).slider('option', 'max', -maxValue);
          } else if (
            (self.isRTLScale && self.isReverseScale) ||
            (!self.isRTLScale && !self.isReverseScale)
          ) {
            $(event.target).slider('option', 'min', minValue);
            $(event.target).slider('option', 'max', maxValue);
          }

          if (self.isRTLScale) {
            $(event.target).slider('option', 'range', 'max');
          }

          var rsLength = $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-slider-axis-val').length;
          if (self.isNaScale) {
            rsLength -= 1;
          }

          if (rsLength % 2 != 0) {
            let middleVal = (rsLength - 1) / 2;
            $(event.target)
              .find('.rs-slider-axis-val')
              .eq(middleVal)
              .find('.slider-value-text')
              .css({
                top: 'auto',
                bottom: '35px',
                display: 'block',
              });

            $(event.target)
              .find('.rs-slider-axis-val')
              .eq(middleVal)
              .find('.slider-value-text')
              .addClass('rs-top-val');
          }

          $(event.target)
            .find('.rs-slider-axis-val')
            .eq(0)
            .find('.slider-value-text')
            .addClass('rs-top-val');
          $(event.target)
            .find('.rs-slider-axis-val')
            .eq(rsLength - 1)
            .find('.slider-value-text')
            .addClass('rs-top-val');

          let ele = $(event.target);
          let opt = $(ele).slider('option');

          // Get the number of possible values
          let vals = opt.max - opt.min;

          // Space out values

          let labels =
            $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isna') ==
            'true'
              ? $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val:not(.na-checkbox)')
              : $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val');
          labels.each(function (i, a) {
            $(this).css('left', Math.abs((i / vals) * 100) + '%');
          });

          // Width for slider and value text

          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text')
            .css('white-space', 'normal');

          if (labels.length <= 3) {
            scaleWidth = $(event.target).closest('.rs-wrapper').width() * 0.6;
          } else if (labels.length > 3 && labels.length <= 5) {
            scaleWidth = $(event.target).closest('.rs-wrapper').width() * 0.8;
          } else {
            scaleWidth = $(event.target).closest('.rs-wrapper').width() * 1;
          }

          $(event.target)
            .closest('.rs-wrapper')
            .css({
              width: scaleWidth + 'px',
              minWidth: scaleWidth + 'px',
              maxWidth: scaleWidth + 'px',
            });

          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-cont')
            .css({ 'min-width': '50px', width: 'auto' });

          if (labels.length % 2 == 0) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.45 + 'px');
          } else {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.3 + 'px');
          }

          setTimeout(function () {
            let textLength = $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text span').length;
            let middleTextVal: number;
            if (textLength % 2 != 0) {
              middleTextVal = (textLength - 1) / 2;
            } else {
              middleTextVal = 0;
            }

            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .each(function (i) {
                if (i == 0 || i == textLength - 1 || i == middleTextVal) {
                  sliderValTextHeight[i] = $(this).height();
                  bottomSliderValTextHeight[i] = 0;
                } else {
                  let previousCss = $(this).attr('style');
                  $(this).css({
                    position: 'relative',
                    visibility: 'hidden',
                    display: 'block',
                  });
                  bottomSliderValTextHeight[i] = $(this).height();
                  sliderValTextHeight[i] = 0;
                  $(this).attr('style', previousCss ? previousCss : '');
                }
              });

            let hgtArr: number[] = [];
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .each(function (i) {
                $(this).addClass('show-rs-val');
                $(this).addClass('tooltip-info');
                hgtArr[i] = $(this).outerHeight();
                $(this).removeClass('show-rs-val');
                $(this).removeClass('tooltip-info');
              });

            $(event.target).css('margin-top', Math.max.apply(Math, hgtArr) + 15 + 'px');

            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-cont')
              .css('padding-top', Math.max.apply(Math, hgtArr) + 3 + 'px');
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('height', Math.max.apply(Math, sliderValTextHeight) + 25 + 'px');

            if (Math.max.apply(Math, bottomSliderValTextHeight) == 0) {
              $(event.target).css('margin-bottom', '50px');
            } else {
              $(event.target).css(
                'margin-bottom',
                Math.max.apply(Math, bottomSliderValTextHeight) + 25 + 'px',
              );
            }
            let mainHgt = 0;
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text span')
              .each(function (i) {
                let a = parseInt($(this).css('line-height'));
                if (isNaN(a)) {
                  a = (parseInt($(this).css('font-size')) + 1) * 1.15;
                }
                if (4 * a < $(this).outerHeight()) {
                  $(this).css({
                    'max-height': 4 * a + 5 + 'px',
                  });
                  $(this)
                    .closest('.slider-value-text')
                    .css('max-height', 4 * a + 25 + 'px');
                  mainHgt = 4 * a + 25;
                } else {
                  $(this).css('max-height', $(this).outerHeight() + 5 + 'px');
                  $(this)
                    .closest('.slider-value-text')
                    .css('max-height', $(this).outerHeight() + 25 + 'px');
                  mainHgt = $(this).outerHeight() + 25;
                }
              });

            if (Math.max.apply(Math, hgtArr) + 15 < mainHgt) {
              $(event.target).css('margin-top', mainHgt + 'px');
            }

            $(event.target).closest('.rs-wrapper').css('opacity', '1');
          }, 200);

          if (
            $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isna') ==
            'true'
          ) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .last()
              .remove();
          }

          // Set Value If Recreating or Population
          if (self.questions.selectAnsValue > 0) {
            if (self.isNa(self.questions)) {
              // Pre Pop N/A
              self.questions.isNA = true;
              self.isNA = true;
              let naAnswer = self.questions.Answers[self.questions.Answers.length - 1];
              self.SelectedValue(naAnswer, true, true);
              let defaultValue = self.getDefaultScaleValue(minValue, maxValue);
              $(event.target).slider('value', defaultValue);
              $(event.target).addClass('inactive-scale');
            }
            // If Rating Scale is Reverse
            else {
              if (
                (!self.isRTL && self.questions.isAnchorReverse) ||
                (self.isRTL && !self.questions.isAnchorReverse)
              ) {
                $(event.target).slider('value', -self.questions.selectAnsValue);
              } else {
                $(event.target).slider('value', self.questions.selectAnsValue);
              }
              let boxVal = parseInt(
                $(event.target)
                  .closest('.rs-wrapper')
                  .find($("label[weight='" + self.questions.selectAnsValue + "']"))
                  .closest('.rs-slider-axis-val')
                  .text(),
              );

              if (self.questions.population_type == 3) {
                for (let i = 1; i <= self.questions.selectAnsValue; i++) {
                  $(event.target)
                    .closest('.rs-wrapper')
                    .find($("label[weight='" + i + "']"))
                    .addClass('read-only-enable');
                }
                $(event.target)
                  .closest('.rating-scale-cont')
                  .find('.rs-clear-text')
                  .addClass('disabled');
                $(event.target)
                  .closest('.rating-scale-cont')
                  .find('.rs-clear-text-cont')
                  .addClass('disabled1');
              }

              $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val(boxVal);
              $(event.target)
                .closest('.rs-wrapper')
                .find('.rs-slider-axis-wrapper')
                .find($(`label[weight='${self.questions.selectAnsValue}']`))
                .find('.slider-value-text')
                .addClass('show-rs-val');

              // Enable Scale
              $(event.target).find('.ui-slider-handle').css('opacity', '1');
              $(event.target).find('.ui-slider-range').css('opacity', '1');
              $(event.target).removeClass('inactive-scale');
            }

            // ADA
            self.setRuntimeADAProperties(event.target, self.questions.selectAnsValue);
          } else {
            let defaultValue = self.getDefaultScaleValue(minValue, maxValue);
            $(event.target).slider('value', defaultValue);

            // Disable Scale
            $(event.target).find('.ui-slider-range').css('opacity', '0');
            $(event.target).addClass('inactive-scale');
            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-text')
              .addClass('disabled');
            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-text-cont')
              .addClass('disabled1');

            // ADA
            self.clearRuntimeADAProperties(event.target);
          }

          if (self.questions.isValid) {
            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-text')
              .removeClass('disabled');
            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-text-cont')
              .removeClass('disabled1');
            $(event.target)
              .closest('.rating-scale-cont')
              .find('.rs-clear-inp')
              .val(self.service.rsInputValue);
          }
          self.setADAProperties(event.target);
        },
        start: function (event, ui) {
          let selectedVal = Math.abs(ui.value);
          $(event.target)
            .closest('.rs-wrapper')
            .find($("label[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .find('.slider-value-text')
            .addClass('show-rs-val');
          let labelValue = parseInt(
            $(event.target)
              .closest('.rs-wrapper')
              .find($("label[weight='" + selectedVal + "']"))
              .closest('.rs-slider-axis-val')
              .text(),
          );
          $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val(labelValue);

          if ($(event.target).closest('.rs-wrapper').find('.na-checkbox input').is(':checked')) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('input[type="radio"]')
              .prop('checked', false);
            $(event.target).closest('.rs-wrapper').find('.ui-slider-range').css('opacity', '0');
            $(event.target)
              .closest('.rs-wrapper')
              .find('.na-checkbox input')
              .prop('checked', false);
          }
          $(event.target).find('.ui-slider-handle').css('opacity', '1');
          $(event.target).find('.ui-slider-range').css('opacity', '1');
          $(event.target).removeClass('inactive-scale');

          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text')
            .removeClass('disabled');
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text-cont')
            .removeClass('disabled1');

          $(event.target).find('.slider-value-text').removeClass('tooltip-info');

          let labelCount = $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val');
          if (labelCount.length % 2 == 0) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.45 + 'px');
          } else {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text')
              .css('width', $(event.target).closest('.rs-wrapper').width() * 0.3 + 'px');
          }

          if (
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val span')
              .text() != ''
          ) {
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val')
              .addClass('tooltip-info');
            $(event.target)
              .closest('.rs-wrapper')
              .find('.slider-value-text.show-rs-val.tooltip-info')
              .css(
                'width',
                $(event.target).find('.slider-value-text.show-rs-val.tooltip-info span').text()
                  .length *
                  10 +
                  10 +
                  'px',
              );
          }
        },
        stop: function (event, ui) {
          let selectedVal: number;

          if ($(event.target).slider('option', 'value') == null) {
            if (
              $(event.target)
                .closest('.rs-wrapper')
                .find('.rs-slider-axis-wrapper')
                .attr('isrev') == 'true'
            ) {
              selectedVal = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .last()
                  .attr('weight')
                  .trim(),
              );
            } else {
              selectedVal = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .first()
                  .attr('weight')
                  .trim(),
              );
            }
            if (self.questions.RS_Type == 2 && selectedVal >= 0) {
              selectedVal = selectedVal + 1;
            }
            self.SetDataValue(selectedVal, true);
          } else {
            selectedVal = Math.abs($(event.target).slider('option', 'value'));
            if (self.questions.RS_Type == 2 && selectedVal >= 0) {
              selectedVal = selectedVal + 1;
            }
            self.SetDataValue(selectedVal, true);
            self.nextQuestion(event.target);
            // ADA
            self.setRuntimeADAProperties(event.target, selectedVal);
          }

          $(event.target)
            .closest('.rs-wrapper')
            .find($("input[weight='" + selectedVal + "']"))
            .prop('checked', true);
          $(event.target)
            .closest('.rs-wrapper')
            .find($("input[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .show();

          if ($(event.target).find('.slider-value-text.show-rs-val').length > 0) {
            $(event.target).find('.slider-value-text.rs-top-val').hide();
          } else {
            $(event.target).find('.slider-value-text.rs-top-val').show();
          }
        },
      });
    } else {
      // Mobile Rating Slider
      $('#' + id).slider({
        value: null,
        step: 1,
        range: 'min',
        slide: function (event, ui) {
          let selectedVal = Math.abs(ui.value) - 1;
          self.isRTLScale = $(event.target).parents().hasClass('RTLDir');
          self.isReverseScale =
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider-axis-wrapper')
              .attr('isrev') == 'true';
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find($("input[weight='" + selectedVal + "']"))
            .prop('checked', true);
          $(event.target).closest('.rs-mobile-wrapper').find('.rs-slider-axis-val').hide();

          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find($("label[weight='" + (selectedVal + 1) + "']"))
            .closest('.rs-slider-axis-val')
            .show();

          let boxVal = parseInt(
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find($("label[weight='" + (selectedVal + 1) + "']"))
              .closest('.rs-slider-axis-val')
              .find('.rs-weight')
              .text(),
          );
          $(event.target).closest('.rs-mobile-cont').find('.rs-clear-inp').val(boxVal);
          $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text').removeClass('disabled');
          $(event.target)
            .closest('.rs-mobile-cont')
            .find('.rs-clear-text-cont')
            .removeClass('disabled1');

          if (
            $(event.target).find('.rs-slider-axis-wrapper span.palette ').hasClass('palette-12')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette12');
            $(event.target)
              .closest('.rs-mobile-cont')
              .removeClass('Slide25 Slide50 Slide65 Slide75 Slide85 Slide100');

            let maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
            if (self.isReverseScale || self.isRTL)
              maxValue = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .first()
                  .attr('weight')
                  .trim(),
              );
            if (self.isReverseScale && self.isRTL)
              maxValue = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .last()
                  .attr('weight')
                  .trim(),
              );

            if (maxValue == 5) {
              if ((!self.isReverseScale && boxVal == 2) || (self.isReverseScale && boxVal == 4)) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
              } else if (boxVal == 3) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
              } else if (
                (!self.isReverseScale && boxVal == 4) ||
                (self.isReverseScale && boxVal == 2)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide75');
              } else if (
                (!self.isReverseScale && boxVal == 5) ||
                (self.isReverseScale && boxVal == 1)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
              }
            } else if (maxValue == 7) {
              if (
                (!self.isReverseScale && (boxVal == 2 || boxVal == 3)) ||
                (self.isReverseScale && (boxVal == 5 || boxVal == 6))
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
              } else if (boxVal == 4) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
              } else if (
                (!self.isReverseScale && boxVal == 5) ||
                (self.isReverseScale && boxVal == 3)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide65');
              } else if (
                (!self.isReverseScale && boxVal == 6) ||
                (self.isReverseScale && boxVal == 2)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide85');
              } else if (
                (!self.isReverseScale && boxVal == 7) ||
                (self.isReverseScale && boxVal == 1)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
              }
            } else {
              if (boxVal == 2) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
              } else if (
                (!self.isReverseScale && boxVal == 3) ||
                (self.isReverseScale && boxVal == 1)
              ) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
              }
            }
          }

          if (
            $(event.target).find('.rs-slider-axis-wrapper span.palette ').hasClass('palette-21')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette21');
            $(event.target)
              .closest('.rs-mobile-cont')
              .removeClass('Slide60 Slide70 Slide80 Slide90 Slide100');

            if (boxVal >= 0 && boxVal <= 6) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide60');
            } else if (boxVal == 7) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide70');
            } else if (boxVal == 8) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide80');
            } else if (boxVal == 9) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide90');
            } else if (boxVal == 10) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
            }
          }
          // ADA
          self.setRuntimeADAProperties(event.target, boxVal);
        },
        create: function (event) {
          self.isRTLScale = $(event.target).parents().hasClass('RTLDir');
          self.isReverseScale =
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider-axis-wrapper')
              .attr('isrev') == 'true';
          let minValue = parseInt(
            $(event.target)
              .parents('.answer-option-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .first()
              .attr('weight')
              .trim(),
          );
          let maxValue = 0;

          if ($(event.target).closest('.rs-mobile-wrapper').find('.na-checkbox').length > 0) {
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .eq(-2)
                .attr('weight')
                .trim(),
            );
          } else {
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
          }

          if (
            (self.isRTLScale && !self.isReverseScale) ||
            (!self.isRTLScale && self.isReverseScale)
          ) {
            $(event.target).slider('option', 'min', -minValue);
            $(event.target).slider('option', 'max', -maxValue);
          } else {
            $(event.target).slider('option', 'min', minValue);
            $(event.target).slider('option', 'max', maxValue);
          }

          if (self.isRTLScale) {
            $(event.target).slider('option', 'range', 'max');
          }

          let ele = $(event.target);
          let opt = $(ele).slider('option');

          // Get the number of possible values
          let vals = opt.max - opt.min;

          // Space out values

          let labels =
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider-axis-wrapper')
              .attr('isna') == 'true'
              ? $(event.target)
                  .closest('.rs-mobile-wrapper')
                  .find('.rs-slider-axis-val:not(.na-checkbox)')
              : $(event.target).closest('.rs-mobile-wrapper').find('.rs-slider-axis-val');
          labels.each(function (i, a) {
            $(this).css('left', Math.abs((i / vals) * 100) + '%');
          });

          // Width for slider and value text
          let sliderValText: number[] = [],
            count = 0,
            allCount = 0,
            sliderValTextHeight: number[] = [];

          let centerBlank = false,
            endsFilled = false,
            allBlank = false;
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.slider-value-text')
            .each(function (i) {
              sliderValText[i] =
                Math.floor($(this).outerWidth()) > 240 ? 240 : Math.floor($(this).outerWidth());
            });

          if (sliderValText.indexOf(240) > -1) {
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.slider-value-text')
              .css('white-space', 'normal');
          }
          for (let i = 1; i < sliderValText.length - 1; i++) {
            if (sliderValText[i] == 0) {
              count++;
            }
          }
          for (let j = 0; j < sliderValText.length - 1; j++) {
            if (sliderValText[j] == 0) {
              allCount++;
            }
          }

          if (allCount == sliderValText.length - 1) {
            allBlank = true;
          }

          if (count == sliderValText.length - 2) {
            centerBlank = true;
          }

          if (
            (sliderValText[0] > 0 && sliderValText[sliderValText.length - 1] > 0) ||
            (sliderValText[0] > 0 && sliderValText[sliderValText.length - 1] == 0) ||
            (sliderValText[0] == 0 && sliderValText[sliderValText.length - 1] > 0)
          ) {
            endsFilled = true;
          }

          if (centerBlank && endsFilled) {
            let maxWidth = Math.max.apply(Math, sliderValText);
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.slider-value-text')
              .each(function (i) {
                $(this).css('width', maxWidth);
              });
            $(event.target).css({ 'margin-left': maxWidth / 2, 'margin-right': maxWidth / 2 });
          } else if (allBlank) {
            $(this).css('width', 'auto');
          } else {
            const maxWidth = Math.max.apply(Math, sliderValText);

            if (maxWidth == 0) {
              const newWidth = ($(event.target).width() / 11) * sliderValText.length;
              if (newWidth >= 230) {
                $(event.target).css('width', newWidth);
              }
            } else {
              const newWidth = ($(event.target).width() / 11) * sliderValText.length;
              if (newWidth >= 230) {
                $(event.target).css('min-width', newWidth);
              }
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.slider-value-text')
                .each(function (i) {
                  $(this).css('width', maxWidth);
                });
              $(event.target).css('width', sliderValText.length * maxWidth);
            }
          }
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.slider-value-text')
            .each(function (i) {
              sliderValTextHeight[i] = $(this).height();
            });
          $(event.target).css('margin-top', Math.max.apply(Math, sliderValTextHeight) + 25 + 'px');
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-cont')
            .css('padding-top', Math.max.apply(Math, sliderValTextHeight) + 17 + 'px');
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.slider-value-text')
            .css('height', Math.max.apply(Math, sliderValTextHeight) + 25 + 'px');
          if (
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider-axis-wrapper')
              .attr('isna') == 'true'
          ) {
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .last()
              .remove();
          }

          // Set Value If Recreating or Population
          if (self.questions.selectAnsValue > 0) {
            let selVal = self.questions.selectAnsValue;
            if (self.questions.RS_Type == 2) {
              selVal = self.questions.selectAnsValue - 1;
            }

            if (self.isNa(self.questions)) {
              self.isNA = true;
              self.questions.isNA = true;
              let naAnswer = self.questions.Answers[self.questions.Answers.length - 1];
              self.SelectedValue(naAnswer, true, true);
              let defaultValue = self.getDefaultScaleValue(minValue, maxValue);
              $(event.target).slider('value', defaultValue);
            } else {
              if (
                (!self.isRTL && self.questions.isAnchorReverse) ||
                (self.isRTL && !self.questions.isAnchorReverse)
              ) {
                $(event.target).slider('value', -selVal);
              } else {
                $(event.target).slider('value', selVal);
              }
              let boxValue = parseInt(
                $(event.target)
                  .find('.rs-slider-axis-wrapper')
                  .find(`label[weight='${selVal}']`)
                  .find('.rs-weight')
                  .text(),
              );

              if (self.questions.population_type == 3) {
                for (let i = 1; i <= selVal; i++) {
                  $(event.target)
                    .find('.rs-slider-axis-wrapper')
                    .find($("label[weight='" + i + "']"))
                    .addClass('read-only-enable');
                }
                $(event.target)
                  .closest('.rating-scale-cont')
                  .find('.rs-clear-text')
                  .addClass('disabled');
                $(event.target)
                  .closest('.rating-scale-cont')
                  .find('.rs-clear-text-cont')
                  .addClass('disabled1');
              }
              $(event.target).closest('.rs-mobile-wrapper').find('.rs-clear-inp').val(boxValue);
            }
            $(event.target).find('.ui-slider-handle').css('opacity', '1');
            $(event.target).find('.ui-slider-range').css('opacity', '1');
            $(event.target).removeClass('inactive-scale');
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find($("label[weight='" + selVal + "']"))
              .closest('.rs-slider-axis-val')
              .show();

            setTimeout(function () {
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.slider-value-text')
                .removeClass('tooltip-weight');
              $(event.target).closest('.rs-mobile-wrapper').find('.rs-overlay').hide();
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.rs-end-values-cont')
                .css('visibility', 'hidden');
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.rs-end-values-cont')
                .removeClass('white-font');
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.rs-slider')
                .removeClass('active-slider');

              if (
                $(event.target).closest('.rs-mobile-wrapper').find('.rs-smiley-cont').length > 0
              ) {
                $(event.target)
                  .closest('.rs-mobile-wrapper')
                  .find('.rs-smiley-cont')
                  .removeClass('smiley-active');
              }
            }, 100);

            let maxSliderValue = $(event.target)
              .closest('.answer-option-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .last()
              .attr('weight');
            if (maxSliderValue == selVal) {
              $(event.target).find('.ui-slider-handle').css('left', '100%');
            }

            if (
              $(event.target).find('.rs-slider-axis-wrapper span.palette ').hasClass('palette-12')
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette12');
              $(event.target)
                .closest('.rs-mobile-cont')
                .removeClass('Slide25 Slide50 Slide75 Slide100');

              let maxValue = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .last()
                  .attr('weight')
                  .trim(),
              );
              if (self.isReverseScale || self.isRTL)
                maxValue = parseInt(
                  $(event.target)
                    .parents('.answer-option-wrapper')
                    .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                    .first()
                    .attr('weight')
                    .trim(),
                );
              if (self.isReverseScale && self.isRTL)
                maxValue = parseInt(
                  $(event.target)
                    .parents('.answer-option-wrapper')
                    .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                    .last()
                    .attr('weight')
                    .trim(),
                );

              if (maxValue == 5) {
                if ((!self.isReverseScale && selVal == 2) || (self.isReverseScale && selVal == 4)) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
                } else if (self.questions.selectAnsValue == 3) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
                } else if (
                  (!self.isReverseScale && selVal == 4) ||
                  (self.isReverseScale && selVal == 2)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide75');
                } else if (
                  (!self.isReverseScale && selVal == 5) ||
                  (self.isReverseScale && selVal == 1)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
                }
              } else if (maxValue == 7) {
                if (
                  (!self.isReverseScale && (selVal == 2 || selVal == 3)) ||
                  (self.isReverseScale && (selVal == 5 || selVal == 6))
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
                } else if (selVal == 4) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
                } else if (
                  (!self.isReverseScale && selVal == 5) ||
                  (self.isReverseScale && selVal == 3)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide65');
                } else if (
                  (!self.isReverseScale && selVal == 6) ||
                  (self.isReverseScale && selVal == 2)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide85');
                } else if (
                  (!self.isReverseScale && selVal == 7) ||
                  (self.isReverseScale && selVal == 1)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
                }
              } else {
                if (selVal == 2) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
                } else if (
                  (!self.isReverseScale && selVal == 3) ||
                  (self.isReverseScale && selVal == 1)
                ) {
                  $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
                }
              }
            }

            if (
              $(event.target).find('.rs-slider-axis-wrapper span.palette ').hasClass('palette-21')
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette21');
              $(event.target)
                .closest('.rs-mobile-cont')
                .removeClass('Slide60 Slide70 Slide80 Slide90 Slide100');

              if (selVal >= 0 && selVal <= 6) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide60');
              } else if (selVal == 7) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide70');
              } else if (selVal == 8) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide80');
              } else if (selVal == 9) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide90');
              } else if (selVal == 10) {
                $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
              }
            }
          } else {
            let defaultValue = self.getDefaultScaleValue(minValue, maxValue);
            $(event.target).slider('value', defaultValue);
            $(event.target).find('.ui-slider-range').css('opacity', '0');
            $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text').addClass('disabled');
            $(event.target)
              .closest('.rs-mobile-cont')
              .find('.rs-clear-text-cont')
              .addClass('disabled1');

            // ADA
            self.clearRuntimeADAProperties(event.target);
          }

          if (self.questions.isValid) {
            $(event.target)
              .closest('.rs-mobile-cont')
              .find('.rs-clear-text')
              .removeClass('disabled');
            $(event.target)
              .closest('.rs-mobile-cont')
              .find('.rs-clear-text-cont')
              .removeClass('disabled1');
            $(event.target)
              .closest('.rs-mobile-cont')
              .find('.rs-clear-inp')
              .val(self.service.rsInputValue);
          }

          $(event.target).find('.slider-value-text').addClass('slider-label-width');

          if (
            $(event.target)
              .closest('.rs-slider')
              .find('.rs-slider-axis-wrapper span.palette ')
              .hasClass('palette-12')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette12');
            if (self.isReverseScale) {
              $(event.target).closest('.rs-mobile-cont').addClass('ReverseOrder');
            }
            if (self.isRTLScale) {
              $(event.target).closest('.rs-mobile-cont').addClass('isRTL');
            }
          }

          if (
            $(event.target)
              .closest('.rs-slider')
              .find('.rs-slider-axis-wrapper span.palette ')
              .hasClass('palette-21')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette21');
            if (self.isReverseScale) {
              $(event.target).closest('.rs-mobile-cont').addClass('ReverseOrder');
            }
            if (self.isRTLScale) {
              $(event.target).closest('.rs-mobile-cont').addClass('isRTL');
            }
          }
          // ADA
          self.setADAProperties(event.target);
        },
        start: function (event, ui) {
          if (
            $(event.target).closest('.rs-mobile-wrapper').find('.na-checkbox input').is(':checked')
          ) {
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('input[type="radio"]')
              .prop('checked', false);
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.ui-slider-range')
              .css('opacity', '0');
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.na-checkbox input')
              .prop('checked', false);
          }

          let selectedVal = Math.abs(ui.value);
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find($("label[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .find('.slider-value-text')
            .addClass('show-rs-val');
          let labelValue = parseInt(
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find($("label[weight='" + selectedVal + "']"))
              .closest('.rs-slider-axis-val')
              .find('.rs-weight')
              .text(),
          );
          $(event.target).closest('.rs-mobile-cont').find('.rs-clear-inp').val(labelValue);

          $(event.target).find('.ui-slider-handle').css('opacity', '1');
          $(event.target).find('.ui-slider-range').css('opacity', '1');
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.slider-value-text')
            .addClass('tooltip-weight');
          $(event.target).closest('.rs-mobile-wrapper').find('.rs-overlay').show();
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.rs-end-values-cont')
            .addClass('white-font');
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.rs-end-values-cont')
            .css('visibility', 'visible');
          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find('.rs-slider')
            .addClass('active-slider');

          if ($(event.target).closest('.rs-mobile-wrapper').find('.rs-smiley-cont').length > 0) {
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-smiley-cont')
              .addClass('smiley-active');
          }

          $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text').removeClass('disabled');
          $(event.target)
            .closest('.rs-mobile-cont')
            .find('.rs-clear-text-cont')
            .removeClass('disabled1');
        },
        stop: function (event, ui) {
          let selectedVal: number;

          if ($(event.target).slider('option', 'value') == null) {
            if (
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.rs-slider-axis-wrapper')
                .attr('isrev') == 'true'
            ) {
              selectedVal = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .last()
                  .attr('weight')
                  .trim(),
              );
            } else {
              selectedVal = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .first()
                  .attr('weight')
                  .trim(),
              );
            }
            if (self.questions.RS_Type == 2 && selectedVal >= 0) {
              self.SetDataValue(selectedVal + 1, true);
            } else {
              self.SetDataValue(selectedVal, true);
            }
          } else {
            selectedVal = Math.abs($(event.target).slider('option', 'value'));
            if (self.questions.RS_Type == 2 && selectedVal >= 0) {
              self.SetDataValue(selectedVal + 1, true);
            } else {
              self.SetDataValue(selectedVal, true);
            }

            self.nextQuestion(event.target);
            // ADA
            self.setRuntimeADAProperties(event.target, selectedVal);
          }

          let maxSliderValue = $(event.target)
            .closest('.answer-option-wrapper')
            .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
            .last()
            .attr('weight');
          if (maxSliderValue == selectedVal) {
            $(event.target).find('.ui-slider-handle').css('left', '100%');
          }

          if (
            $(event.target)
              .closest('.rs-slider')
              .find('.rs-slider-axis-wrapper span.palette ')
              .hasClass('palette-12')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette12');
            $(event.target)
              .closest('.rs-mobile-cont')
              .removeClass('Slide25 Slide50 Slide75 Slide100');
            if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '25%') {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
            } else if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '50%') {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 66
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide65');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 83
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide85');
            } else if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '75%') {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide75');
            } else if (
              $(event.target).find('.ui-slider-range').prop('style')['width'] == '100%' ||
              $(event.target).find('.ui-slider-range').prop('style')['width'] == '98%'
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
            }
          }

          if (
            $(event.target)
              .closest('.rs-slider')
              .find('.rs-slider-axis-wrapper span.palette ')
              .hasClass('palette-21')
          ) {
            $(event.target).closest('.rs-mobile-cont').addClass('SmileyPalette21');
            $(event.target)
              .closest('.rs-mobile-cont')
              .removeClass('Slide25 Slide60 Slide70 Slide80 Slide90 Slide100');
            if (parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) <= 60) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide60');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 70
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide70');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 80
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide80');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 90
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide90');
            } else if (
              parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 100
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide100');
            }
          }

          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find($("input[weight='" + selectedVal + "']"))
            .prop('checked', true);
          $(event.target).closest('.rs-mobile-wrapper').find('.rs-slider-axis-val').hide();

          $(event.target)
            .closest('.rs-mobile-wrapper')
            .find($("label[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .show();
          setTimeout(function () {
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.slider-value-text')
              .removeClass('tooltip-weight');
            $(event.target).closest('.rs-mobile-wrapper').find('.rs-overlay').hide();
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-end-values-cont')
              .css('visibility', 'hidden');
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-end-values-cont')
              .removeClass('white-font');
            $(event.target)
              .closest('.rs-mobile-wrapper')
              .find('.rs-slider')
              .removeClass('active-slider');

            if ($(event.target).closest('.rs-mobile-wrapper').find('.rs-smiley-cont').length > 0) {
              $(event.target)
                .closest('.rs-mobile-wrapper')
                .find('.rs-smiley-cont')
                .removeClass('smiley-active');
            }
          }, 100);
        },
      });
    }

    $('#' + id + '_Smiley').slider({
      value: null,
      step: 1,
      range: 'min',
      slide: function (event, ui) {
        let selectedVal = Math.abs(ui.value);
        self.isReverseScale =
          $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isrev') ==
          'true';
        $(event.target).closest('.rs-wrapper').find('input[type=radio]').prop('checked', false);
        $(event.target)
          .closest('.rs-wrapper')
          .find("input[weight='" + selectedVal + "']")
          .prop('checked', true);
        let checkedvalue = $(event.target).closest('.rs-wrapper').find('input[type=radio]:checked');
        $(event.target)
          .closest('.rs-smiley-wrapper')
          .attr('data-state', checkedvalue.attr('state') + '_' + checkedvalue.attr('weight'));

        $(event.target)
          .closest('.rs-smiley-wrapper')
          .find('.show-rs-val')
          .removeClass('show-rs-val');
        $(event.target)
          .closest('.rs-smiley-wrapper')
          .find($("label[weight='" + selectedVal + "']"))
          .closest('.rs-slider-axis-val')
          .find('.slider-value-text')
          .addClass('show-rs-val');
        let currLabelValue = parseInt(
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find($("label[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .text(),
        );
        $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val(currLabelValue);
        $(event.target)
          .closest('.rs-smiley-wrapper')
          .find('.smiley-rs-icon')
          .addClass('selected')
          .removeClass('unselected');

        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette ')
            .hasClass('palette-12')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette12');
          $(event.target)
            .closest('.rs-smiley-parent')
            .removeClass('Slide25 Slide50 Slide65 Slide75 Slide85 Slide100');
          let maxValue = parseInt(
            $(event.target)
              .parents('.answer-option-wrapper')
              .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
              .last()
              .attr('weight')
              .trim(),
          );
          if (self.isReverseScale || self.isRTL)
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .first()
                .attr('weight')
                .trim(),
            );
          if (self.isReverseScale && self.isRTL)
            maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
          if (maxValue == 5) {
            if (
              (!self.isReverseScale && selectedVal == 2) ||
              (self.isReverseScale && selectedVal == 4)
            ) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide25');
            } else if (selectedVal == 3) {
              $(event.target).closest('.rs-mobile-cont').addClass('Slide50');
            } else if (
              (!self.isReverseScale && selectedVal == 4) ||
              (self.isReverseScale && selectedVal == 2)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide75');
            } else if (
              (!self.isReverseScale && selectedVal == 5) ||
              (self.isReverseScale && selectedVal == 1)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
            }
          } else if (maxValue == 7) {
            if (
              (!self.isReverseScale && (selectedVal == 2 || selectedVal == 3)) ||
              (self.isReverseScale && (selectedVal == 5 || selectedVal == 6))
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide25');
            } else if (selectedVal == 4) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
            } else if (
              (!self.isReverseScale && selectedVal == 5) ||
              (self.isReverseScale && selectedVal == 3)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide65');
            } else if (
              (!self.isReverseScale && selectedVal == 6) ||
              (self.isReverseScale && selectedVal == 2)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide85');
            } else if (
              (!self.isReverseScale && selectedVal == 7) ||
              (self.isReverseScale && selectedVal == 1)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
            }
          } else {
            if (selectedVal == 2) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
            } else if (
              (!self.isReverseScale && selectedVal == 3) ||
              (self.isReverseScale && selectedVal == 1)
            ) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
            }
          }
        }

        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette ')
            .hasClass('palette-21')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette21');
          $(event.target)
            .closest('.rs-smiley-parent')
            .removeClass('Slide60 Slide70 Slide80 Slide90 Slide100');

          if (selectedVal >= 0 && selectedVal <= 6) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide60');
          } else if (selectedVal == 7) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide70');
          } else if (selectedVal == 8) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide80');
          } else if (selectedVal == 9) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide90');
          } else if (selectedVal == 10) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
          }
        }
        // ADA
        self.setRuntimeADAProperties(event.target, selectedVal);

        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');

        $(event.target)
          .find('.rs-slider-axis-val')
          .each(function (i) {
            if ($(this).hasClass('visible-label-text')) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });

        $(event.target).find('.slider-value-text').removeClass('tooltip-info');
        $(event.target)
          .find('.slider-value-text.show-rs-val span')
          .each(function (i) {
            if ($(this).text() != '') {
              $(this).parents('.slider-value-text').addClass('tooltip-info');
              $(this)
                .parents('.slider-value-text.tooltip-info')
                .css('width', $(this).text().length * 10 + 10 + 'px');
              $(this).parents('.rs-slider-axis-val').show();
            }
          });

        $(event.target)
          .find('.slider-value-text')
          .each(function (i) {
            if (!$(this).hasClass('tooltip-info')) {
              $(this).css('width', $(event.target).closest('.rs-wrapper').width() * 0.25 + 'px');
            }
          });

        $(event.target)
          .find('.slider-value-text')
          .each(function (i) {
            if (!$(this).hasClass('tooltip-info')) {
              $(this).css(
                'width',
                $(event.target).closest('.rs-wrapper').find('.rs-smiley-parent').width() * 0.25 +
                  'px',
              );
            }
          });
      },
      create: function (event) {
        $(event.target).closest('.rs-wrapper').css('opacity', '0');
        self.isRTLScale = $(event.target).parents().hasClass('RTLDir');
        self.isReverseScale =
          $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isrev') ==
          'true';
        let minValue = parseInt(
          $(event.target)
            .parents('.answer-option-wrapper')
            .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
            .first()
            .attr('weight')
            .trim(),
        );
        let maxValue = parseInt(
          $(event.target)
            .parents('.answer-option-wrapper')
            .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
            .last()
            .attr('weight')
            .trim(),
        );

        if (
          (self.isRTLScale && !self.isReverseScale) ||
          (!self.isRTLScale && self.isReverseScale)
        ) {
          $(event.target).slider('option', 'min', -minValue);
          $(event.target).slider('option', 'max', -maxValue);
        } else if (
          (self.isRTLScale && self.isReverseScale) ||
          (!self.isRTLScale && !self.isReverseScale)
        ) {
          $(event.target).slider('option', 'min', minValue);
          $(event.target).slider('option', 'max', maxValue);
        }

        if (self.isRTLScale) {
          $(event.target).slider('option', 'range', 'max');
        }

        let ele = $(event.target);
        let opt = $(ele).slider('option');

        // Get the number of possible values
        let vals = opt.max - opt.min;

        // Space out values
        let labels = $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val');
        labels.each(function (i, a) {
          $(this).css('left', Math.abs((i / vals) * 100) + '%');
        });

        // Width for slider and value text
        let sliderValText: number[] = [],
          count = 0,
          sliderValTextHeight: number[] = [];
        let allBlank = false,
          allCount = 0;
        $(event.target)
          .closest('.rs-wrapper')
          .find('.slider-value-text')
          .each(function (i) {
            sliderValText[i] =
              Math.floor($(this).outerWidth()) > 240 ? 240 : Math.floor($(this).outerWidth());
          });
        for (var i = 1; i < sliderValText.length - 1; i++) {
          if (sliderValText[i] == 0) {
            count++;
          }
        }

        for (const sliderValTextItem of sliderValText) {
          if (sliderValTextItem == 0) {
            allCount++;
          }
        }

        if (allCount == sliderValText.length - 1) {
          allBlank = true;
        }

        if (!allBlank) {
          let maxWidth = Math.max.apply(Math, sliderValText);
          $(event.target).css({ 'margin-left': maxWidth / 2, 'margin-right': maxWidth / 2 });
        }

        setTimeout(function () {
          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text')
            .each(function (i) {
              sliderValTextHeight[i] = $(this).height();
            });

          let hgtArr: number[] = [];
          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text')
            .each(function (i) {
              $(this).addClass('show-rs-val');
              $(this).addClass('tooltip-info');
              hgtArr[i] = $(this).outerHeight();
              $(this).removeClass('show-rs-val');
              $(this).removeClass('tooltip-info');
            });

          $(event.target).css('margin-top', Math.max.apply(Math, hgtArr) + 25 + 'px');
          let mainHgt = 0;
          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text span')
            .each(function (i) {
              let a = parseInt($(this).css('line-height'));
              if (isNaN(a)) {
                a = (parseInt($(this).css('font-size')) + 1) * 1.15;
              }
              if (4 * a < $(this).outerHeight()) {
                $(this).css({
                  'max-height': 4 * a + 5 + 'px',
                });
                $(this)
                  .closest('.slider-value-text')
                  .css('max-height', 4 * a + 25 + 'px');
                mainHgt = 4 * a + 25;
              } else {
                $(this).css('max-height', $(this).outerHeight() + 5 + 'px');
                $(this)
                  .closest('.slider-value-text')
                  .css('max-height', $(this).outerHeight() + 25 + 'px');
                mainHgt = $(this).outerHeight() + 25;
              }
            });

          if (Math.max.apply(Math, hgtArr) + 15 < mainHgt) {
            $(event.target).css('margin-top', mainHgt + 'px');
          }

          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-cont')
            .css('padding-top', Math.max.apply(Math, hgtArr) + 15 + 'px');

          $(event.target).closest('.rs-wrapper').css('opacity', '1');
        }, 200);

        if (self.questions.selectAnsValue > 0) {
          let boxValue = self.questions.selectAnsValue;
          if (self.questions.RS_Type == 2) {
            boxValue = self.questions.selectAnsValue - 1;
          }
          // If Smiley Rating Scale is Reverse
          if (
            (!self.isRTL && self.questions.isAnchorReverse) ||
            (self.isRTL && !self.questions.isAnchorReverse)
          ) {
            $(event.target).slider('value', -boxValue);
          } else {
            $(event.target).slider('value', boxValue);
          }
          $(event.target).find('.ui-slider-handle').css('opacity', '1');
          $(event.target).find('.ui-slider-range').css('opacity', '1');

          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text')
            .removeClass('disabled');
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-clear-text-cont')
            .removeClass('disabled1');
          if (self.questions.population_type == 3) {
            for (let i = 0; i <= boxValue; i++) {
              $(event.target)
                .closest('.rs-wrapper')
                .find(".rs-slider-axis-val[weight='" + i + "']")
                .addClass('read-only-enable');
            }
            $(event.target)
              .closest('.answer-option-wrapper')
              .find('.rs-clear-text')
              .addClass('disabled');
            $(event.target)
              .closest('.answer-option-wrapper')
              .find('.rs-clear-text-cont')
              .addClass('disabled1');
          }

          // Set Smiley Icon & Bold Text Based on The Selected Value
          $(event.target)
            .closest('.rs-wrapper')
            .find($("input[weight='" + boxValue + "']"))
            .prop('checked', true);
          let checkedvalue = $(event.target)
            .closest('.rs-wrapper')
            .find('input[type=radio]:checked');
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .attr('data-state', checkedvalue.attr('state') + '_' + checkedvalue.attr('weight'));
          $(event.target)
            .closest('.rs-wrapper')
            .find(".rs-slider-axis-val[weight='" + boxValue + "'] .slider-value-text")
            .addClass('show-rs-val');
          $(event.target)
            .closest('.rs-wrapper')
            .find('.smiley-rs-icon')
            .addClass('selected')
            .removeClass('unselected');
          // ADA
          $(event.target).find('.ui-slider-handle').attr('aria-valuenow', boxValue);

          if (
            $(event.target)
              .closest('.rs-smiley-wrapper')
              .find('.smiley-rs-icon.palette ')
              .hasClass('palette-12')
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette12');
            $(event.target)
              .closest('.rs-smiley-parent')
              .removeClass('Slide25 Slide50 Slide75 Slide100');
            let maxValue = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
            if (self.isReverseScale || self.isRTL)
              maxValue = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .first()
                  .attr('weight')
                  .trim(),
              );
            if (self.isReverseScale && self.isRTL)
              maxValue = parseInt(
                $(event.target)
                  .parents('.answer-option-wrapper')
                  .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                  .last()
                  .attr('weight')
                  .trim(),
              );
            if (maxValue == 5) {
              if (
                (!self.isReverseScale && boxValue == 2) ||
                (self.isReverseScale && boxValue == 4)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide25');
              } else if (boxValue == 3) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
              } else if (
                (!self.isReverseScale && boxValue == 4) ||
                (self.isReverseScale && boxValue == 2)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide75');
              } else if (
                (!self.isReverseScale && boxValue == 5) ||
                (self.isReverseScale && boxValue == 1)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
              }
            } else if (maxValue == 7) {
              if (
                (!self.isReverseScale && (boxValue == 2 || boxValue == 3)) ||
                (self.isReverseScale && (boxValue == 5 || boxValue == 6))
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide25');
              } else if (boxValue == 4) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
              } else if (
                (!self.isReverseScale && boxValue == 5) ||
                (self.isReverseScale && boxValue == 3)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide65');
              } else if (
                (!self.isReverseScale && boxValue == 6) ||
                (self.isReverseScale && boxValue == 2)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide85');
              } else if (
                (!self.isReverseScale && boxValue == 7) ||
                (self.isReverseScale && boxValue == 1)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
              }
            } else {
              if (boxValue == 2) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
              } else if (
                (boxValue == 3 && !self.isReverseScale) ||
                (self.isReverseScale && boxValue == 1)
              ) {
                $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
              }
            }
          }

          if (
            $(event.target)
              .closest('.rs-smiley-wrapper')
              .find('.smiley-rs-icon.palette ')
              .hasClass('palette-21')
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette21');
            $(event.target)
              .closest('.rs-smiley-parent')
              .removeClass('Slide60  Slide70  Slide80 Slide90 Slide100');

            if (boxValue >= 0 && boxValue <= 6) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide60');
            } else if (boxValue == 7) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide70');
            } else if (boxValue == 8) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide80');
            } else if (boxValue == 9) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide90');
            } else if (boxValue == 10) {
              $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
            }
          }
        } else {
          let defaultValue = self.getDefaultScaleValue(minValue, maxValue);
          $(event.target).slider('value', defaultValue);
          $(event.target).find('.ui-slider-range').css('opacity', '0');
          $(event.target).addClass('inactive-scale');
          $(event.target)
            .closest('.answer-option-wrapper')
            .find('.rs-clear-text')
            .addClass('disabled');
          $(event.target)
            .closest('.answer-option-wrapper')
            .find('.rs-clear-text-cont')
            .addClass('disabled1');
          $(event.target)
            .closest('.rs-wrapper')
            .find('.smiley-rs-icon')
            .addClass('unselected')
            .removeClass('selected');
          if (self.isRTLScale) {
            if (self.isReverseScale) {
              $(event.target)
                .closest('.rs-smiley-wrapper')
                .attr('data-state', maxValue + '_' + maxValue);
            } else {
              $(event.target)
                .closest('.rs-smiley-wrapper')
                .attr('data-state', minValue + '_' + maxValue);
            }
          } else {
            if (self.isReverseScale) {
              $(event.target)
                .closest('.rs-smiley-wrapper')
                .attr('data-state', minValue + '_' + minValue);
            } else {
              $(event.target)
                .closest('.rs-smiley-wrapper')
                .attr('data-state', maxValue + '_' + minValue);
            }
          }
          // ADA
          self.clearRuntimeADAProperties(event.target);
        }
        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette')
            .hasClass('palette-12')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette12');
          if (self.isReverseScale) {
            $(event.target).closest('.rs-smiley-parent').addClass('ReverseOrder');
          }
          if (self.isRTLScale) {
            $(event.target).closest('.rs-smiley-parent').addClass('isRTL');
          }
        }

        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette')
            .hasClass('palette-21')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette21');
          if (self.isReverseScale) {
            $(event.target).closest('.rs-smiley-parent').addClass('ReverseOrder');
          }
          if (self.isRTLScale) {
            $(event.target).closest('.rs-smiley-parent').addClass('isRTL');
          }
        }
        // ADA
        self.setADAProperties(event.target);

        let rsLength = $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-slider-axis-val').length;
        if (self.isNaScale) {
          rsLength -= 1;
        }

        if (rsLength % 2 != 0 && self.questions.RS_Type != 2) {
          let middleVal = (rsLength - 1) / 2;
          $(event.target).find('.rs-slider-axis-val').eq(middleVal).find('.slider-value-text').css({
            top: 'auto',
            bottom: '35px',
            display: 'block',
          });
          $(event.target)
            .find('.rs-slider-axis-val')
            .eq(middleVal)
            .find('.slider-value-text')
            .addClass('rs-top-val');
          $(event.target).find('.rs-slider-axis-val').eq(middleVal).addClass('visible-label-text');
        }

        if (rsLength == 5) {
          $(event.target).find('.rs-slider-axis-val').eq(0).addClass('visible-label-text');
          $(event.target).find('.rs-slider-axis-val').eq(4).addClass('visible-label-text');
        }

        if (rsLength == 7) {
          $(event.target).find('.rs-slider-axis-val').eq(0).addClass('visible-label-text');
          $(event.target).find('.rs-slider-axis-val').eq(6).addClass('visible-label-text');
        }

        if (rsLength == 11) {
          $(event.target).find('.rs-slider-axis-val').eq(0).addClass('visible-label-text');
          $(event.target).find('.rs-slider-axis-val').eq(10).addClass('visible-label-text');
        }

        if (rsLength == 3) {
          $(event.target).find('.rs-slider-axis-val').eq(0).addClass('visible-label-text');
          $(event.target).find('.rs-slider-axis-val').eq(2).addClass('visible-label-text');
        }

        $(event.target)
          .find('.slider-value-text')
          .each(function (i) {
            if (!$(this).hasClass('tooltip-info')) {
              $(this).css(
                'width',
                $(event.target).closest('.rs-wrapper').find('.rs-smiley-parent').width() * 0.25 +
                  'px',
              );
              $(this).css('white-space', 'normal');
            }
          });

        $(window).on('resize', function () {
          $(event.target)
            .find('.slider-value-text')
            .each(function (i) {
              if (!$(this).hasClass('tooltip-info')) {
                $(this).css(
                  'width',
                  $(event.target).closest('.rs-wrapper').find('.rs-smiley-parent').width() * 0.25 +
                    'px',
                );
                $(this).css('white-space', 'normal');
              }
            });

          //  setTimeout(function(){
          $(event.target)
            .closest('.rs-wrapper')
            .find('.slider-value-text span')
            .each(function (i) {
              let a = parseInt($(this).css('line-height'));
              if (isNaN(a)) {
                a = (parseInt($(this).css('font-size')) + 1) * 1.15;
              }
              if (4 * a < $(this).outerHeight()) {
                $(this).css({
                  'max-height': 4 * a + 5 + 'px',
                });
                $(this)
                  .closest('.slider-value-text')
                  .css('max-height', 4 * a + 25 + 'px');
              } else {
                $(this).css('max-height', $(this).outerHeight() + 5 + 'px');
                $(this)
                  .closest('.slider-value-text')
                  .css('max-height', $(this).outerHeight() + 25 + 'px');
              }
            });
          //  }, 500);
        });

        $(event.target)
          .find('.rs-slider-axis-val')
          .each(function (i) {
            if ($(this).hasClass('visible-label-text')) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
      },
      start: function (event, ui) {
        let selectedVal = Math.abs(ui.value);
        $(event.target)
          .closest('.rs-smiley-wrapper')
          .find($("label[weight='" + selectedVal + "']"))
          .closest('.rs-slider-axis-val')
          .find('.slider-value-text')
          .addClass('show-rs-val');
        let currLabelValue = parseInt(
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find($("label[weight='" + selectedVal + "']"))
            .closest('.rs-slider-axis-val')
            .text(),
        );
        $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val(currLabelValue);

        $(event.target).find('.ui-slider-handle').css('opacity', '1');
        $(event.target).find('.ui-slider-range').css('opacity', '1');
        $(event.target).removeClass('inactive-scale');
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.smiley-rs-icon')
          .addClass('selected')
          .removeClass('unselected');
        $(event.target).find('.slider-value-text').removeClass('tooltip-info');
        $(event.target)
          .find('.slider-value-text.show-rs-val span')
          .each(function (i) {
            if ($(this).text() != '') {
              $(this).parents('.slider-value-text').addClass('tooltip-info');
              $(this)
                .parents('.slider-value-text.tooltip-info')
                .css('width', $(this).text().length * 10 + 10 + 'px');
              $(this).parents('.rs-slider-axis-val').show();
            }
          });
      },
      stop: function (event, ui) {
        let selectedVal: number;

        if ($(event.target).slider('option', 'value') == null) {
          if (
            $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-wrapper').attr('isrev') ==
            'true'
          ) {
            selectedVal = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .last()
                .attr('weight')
                .trim(),
            );
          } else {
            selectedVal = parseInt(
              $(event.target)
                .parents('.answer-option-wrapper')
                .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
                .first()
                .attr('weight')
                .trim(),
            );
          }
          if (self.questions.RS_Type == 2 && selectedVal >= 0) {
            self.SetDataValue(selectedVal + 1, true);
          } else {
            self.SetDataValue(selectedVal, true);
          }

          self.SetDataValue(selectedVal, true);
        } else {
          selectedVal = Math.abs($(event.target).slider('option', 'value'));
          if (self.questions.RS_Type == 2 && selectedVal >= 0) {
            self.SetDataValue(selectedVal + 1, true);
          } else {
            self.SetDataValue(selectedVal, true);
          }

          self.nextQuestion(event.target);
        }

        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette ')
            .hasClass('palette-12')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette12');
          $(event.target)
            .closest('.rs-smiley-parent')
            .removeClass('Slide25 Slide50 Slide75 Slide65 Slide85 Slide100');
          if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '25%') {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide25');
          } else if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '50%') {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide50');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 66
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide65');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 83
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide85');
          } else if ($(event.target).find('.ui-slider-range').prop('style')['width'] == '75%') {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide75');
          } else if (
            $(event.target).find('.ui-slider-range').prop('style')['width'] == '100%' ||
            $(event.target).find('.ui-slider-range').prop('style')['width'] == '98%'
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
          }
        }

        if (
          $(event.target)
            .closest('.rs-smiley-wrapper')
            .find('.smiley-rs-icon.palette ')
            .hasClass('palette-21')
        ) {
          $(event.target).closest('.rs-smiley-parent').addClass('SmileyPalette21');
          $(event.target).closest('.rs-smiley-parent').removeClass(' Slide60 Slide80 Slide100');
          if (parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) <= 60) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide60');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 70
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide70');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 80
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide80');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 90
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide90');
          } else if (
            parseInt($(event.target).find('.ui-slider-range').prop('style')['width']) == 100
          ) {
            $(event.target).closest('.rs-smiley-parent').addClass('Slide100');
          }
        }
        $(event.target)
          .closest('.rs-wrapper')
          .find($("input[weight='" + selectedVal + "']"))
          .prop('checked', true);
        let checkedvalue = $(event.target).closest('.rs-wrapper').find('input[type=radio]:checked');
        $(event.target)
          .closest('.rs-smiley-wrapper')
          .attr('data-state', checkedvalue.attr('state') + '_' + checkedvalue.attr('weight'));
        if (
          $(event.target).closest('.rs-smiley-wrapper').find('.slider-value-text.show-rs-val')
            .length > 0
        ) {
          $(event.target).find('.rs-slider-axis-val.visible-label-text').hide();
          $(event.target)
            .find('.slider-value-text.show-rs-val.tooltip-info')
            .parents('.rs-slider-axis-val')
            .show();
        } else {
          $(event.target).find('.rs-slider-axis-val.visible-label-text').show();
        }
      },
    });

    if (this.questions.RS_Type == 2 && this.questions.AnswerText != null) {
      $('#dv_' + this.questions.UniqueNumber)
        .find('.nps-wrapper')
        .addClass('selected');
    }

    this.isAriaRequired =
      (this.questions.mandatory && this.isMandatoryUpfront) ||
      (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        if (this.questions.population_type != 2 && this.questions.population_type != 3) {
          this.isAnsChange = false;
          this.resetScale();
        }
      }
    });
  }
  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  isNa(question: Questions): boolean {
    return question.Answers.find((e) => e.value_id == question.selectAnsValue).isNA;
  }

  SetDataValue(value: number, event: any) {
    let ans = this.questions.Answers.find((e) => e.value_id == value);

    if (ans != null && ans != undefined) {
      ans.ControlAns = ans.value_id;
      this.SelectedValue(ans, event);
    }
  }

  GetQuestionPrePopValue(): string {
    if (this.questions != null && this.questions.PrePopValue > 0) {
      if (
        this.questions.Answers.find((e) => e.value_id == this.questions.PrePopValue).value_text ==
        ''
      ) {
        if (this.questions.PrePopText != '') {
          return this.questions.PrePopText;
        } else if (
          this.questions.Answers.find((e) => e.value_id == this.questions.PrePopValue).isNA
        ) {
          return 'N/A';
        } else {
          return (this.questions.PrePopValue - 1).toString();
        }
      } else {
        if (this.questions.RS_Type == 1) {
          if (this.questions.PrePopText != '') {
            return this.questions.PrePopValue.toString() + ' - ' + this.questions.PrePopText;
          } else {
            return (
              this.questions.PrePopValue.toString() +
              '-' +
              this.questions.Answers.find((e) => e.value_id == this.questions.PrePopValue)
                .value_text
            );
          }
        } else {
          //Issue No. 110104 :RS takes N/A value as 12 when pre read is set
          if (this.questions.PrePopText != '') {
            return this.questions.PrePopText;
          } else {
            return this.questions.Answers.find((e) => e.value_id == this.questions.PrePopValue)
              .value_text;
          }
        }
      }
    }
    return ''; // Default return value
  }

  SelectedValue(answer: Answers, event: any, isNA: boolean = false) {
    if (event && answer) {
      for (const answerItem of this.questions.Answers) {
        if (answer.ms_id === answerItem.ms_id) {
          if (this.questions.isNA && answerItem.isNA && answer.ControlAns == this.questions.AnswerText && answerItem.ms_id == this.questions.AnswerID) {
            return;
          }
          answer.selectdId = 1;
          const ansInd = this.questions.Answers.findIndex((e) => e.ms_id == answer.ms_id);
          this.questions.Answers[ansInd] = answer;
          this.questions.AnswerID = answer.ms_id;
          this.questions.selectAnsValue = answer.value_id;

          if (this.questions.RS_Type == 0 || this.questions.RS_Type == 2) {
            if (this.questions.isNA) {
              this.questions.AnswerText = 'N/A';
            } else {
              this.questions.AnswerText = answer.weight.toString();
            }
          } else {
            this.questions.AnswerText = 'answer.ControlAns';
          }

          this.questions.pageto = answer.pageto;
          this.questions.otherAnswer = null;

          if (!isNA) {
            this.questions.isNA = false;
            this.isNA = false;
          }

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }

          this.questions.isValid = false;
        } else {
          const ansInd = this.questions.Answers.findIndex((e) => e.ms_id == answerItem.ms_id);
          this.questions.Answers[ansInd].ControlAns = null;
          this.questions.Answers[ansInd].selectdId = 0;
        }
      }
    } else if (!answer) {     
      for (const answerItem of this.questions.Answers) {
        answerItem.ControlAns = null;
        answerItem.selectdId = 0;
      }
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;
      this.questions.AnswerText = null;
      this.questions.isValid = true; // This will show the validation message
    } else {
      for (const answerItem of this.questions.Answers) {
        let ansInd = this.questions.Answers.findIndex((e) => e.ms_id == answer.ms_id);
        this.questions.Answers[ansInd].ControlAns = null;
        this.questions.Answers[ansInd].selectdId = 0;
      }
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;
      this.questions.pageto = 0;
      this.questions.AnswerText = null;
      this.questions.otherAnswer = null;
      this.questions.isOtherAnswer = false;
    }
    this.isAnsChange = true;
    if (this.isShowClear) {
      setTimeout(() => this.ChangeAnswersData.emit(this.questions), 1500);
    } else {
      this.ChangeAnswersData.emit(this.questions)
    }
  }

  ddValueChange(event: Event) {
    if ($(event.target).closest('.sl_input').hasClass('showRSValues')) {
      $(event.target).closest('.sl_input').removeClass('showRSValues');
      $(event.target).closest('.sl_input').attr('aria-expanded', 'false');
    } else {
      $('.sl_input').removeClass('showRSValues');
      $(event.target).closest('.sl_input').addClass('showRSValues');
      $(event.target).closest('.sl_input').find('.o-menu-list').focus();
    }
  }

  setRSValue(event: Event, answer: Answers) {
    $(event.target).closest('.sl_input').removeClass('showRSValues');
    $(event.target).closest('.sl_input').find('.rs-clear-inp').val(answer.weight);
    this.setMobileInputRS(event, answer.weight, true);
    this.nextQuestion(event.target);

    if (!this.isNewParticipation && !(this.surveyFormat == 1 || this.surveyFormat == 2)) {
      let id = 'TB_Scale_' + this.questions.UniqueNumber + '_ID';
      setTimeout(function () {
        let control = document.getElementById(id);
        if (control) {
          control.focus();
        }
      }, 50);
    }
  }

  getPlaceHolderValue(): string {
    return this.service.getSurveyMessages().RS_TypeValue;
  }

  disableEnableSlider(elem, isCheked: boolean, answer: Answers, event: Event) {
    if ($(elem).is(':checked')) {
      $(event.target).closest('.rs-wrapper').find('input[type="radio"]').prop('checked', false);
      let minValue = parseInt(
        $(event.target)
          .parents('.answer-option-wrapper')
          .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
          .first()
          .attr('weight')
          .trim(),
      );
      let maxValue = parseInt(
        $(event.target)
          .parents('.answer-option-wrapper')
          .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
          .eq(-1)
          .attr('weight')
          .trim(),
      );
      let defaultValue = this.getDefaultScaleValue(minValue, maxValue);
      $(event.target).closest('.rs-wrapper').find('.rs-slider').slider('value', defaultValue);

      $(event.target).closest('.rs-wrapper').find('.ui-slider-range').css('opacity', '0');
      $(event.target).closest('.rating-scale-cont').find('.rs-slider').addClass('inactive-scale');
      $(event.target).closest('.rating-scale-cont').find('.show-rs-val').removeClass('show-rs-val');
      $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val('');
      $(event.target).closest('.rs-mobile-cont').find('.rs-clear-inp').val('');

      $(event.target)
        .closest('.rs-mobile-wrapper')
        .find('input[type="radio"]')
        .prop('checked', false);
      $(event.target)
        .closest('.rs-mobile-wrapper')
        .find('.rs-slider')
        .slider('value', defaultValue);
      $(event.target).closest('.rs-mobile-wrapper').find('.ui-slider-range').css('opacity', '0');
      $(event.target).closest('.rating-scale-cont').find('.rs-slider').addClass('inactive-scale');

      $('#Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_RS')
        .closest('.rs-mobile-wrapper')
        .find('.rs-slider-axis-val')
        .hide();
      $(event.target)
        .closest('.rs-mobile-wrapper')
        .find('.rs-end-values-cont')
        .css('visibility', 'visible');
      $(event.target).closest('.rating-scale-cont').find('.rs-clear-text').removeClass('disabled');
      $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text').removeClass('disabled');
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.rs-clear-text-cont')
        .removeClass('disabled1');
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.rs-clear-text-cont')
        .removeClass('disabled1');
      this.nextQuestion(event.target);
      this.questions.isValid = false;

      $(event.target).closest('.rating-scale-cont').find('.slider-value-text.rs-top-val').show();

      let labelCount = $(event.target).closest('.rs-wrapper').find('.rs-slider-axis-val');
      if (labelCount.length % 2 == 0) {
        $(event.target)
          .closest('.rs-wrapper')
          .find('.slider-value-text')
          .css('width', $(event.target).closest('.rs-wrapper').width() * 0.45 + 'px');
      } else {
        $(event.target)
          .closest('.rs-wrapper')
          .find('.slider-value-text')
          .css('width', $(event.target).closest('.rs-wrapper').width() * 0.3 + 'px');
      }
    }

    if (isCheked) {
      this.questions.isNA = true;
      this.isNA = true;
      answer.ControlAns = 'N/A';
      this.SelectedValue(answer, true, true);
    } else {
      this.questions.isNA = false;
      this.isNA = false;
      this.SelectedValue(answer, false, false);
      $(event.target).closest('.answer-option-wrapper').find('.rs-clear-text').addClass('disabled');
      $(event.target)
        .closest('.answer-option-wrapper')
        .find('.rs-clear-text-cont')
        .addClass('disabled1');
    }
  }

  clearRatingScale(event: Event) {
    this.isAnsChange = true;
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('input[type="radio"]')
      .prop('checked', false);

    let minValue = parseInt(
      $(event.target)
        .parents('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .first()
        .attr('weight')
        .trim(),
    );
    let maxValue = parseInt(
      $(event.target)
        .parents('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .eq(-1)
        .attr('weight')
        .trim(),
    );
    let defaultValue = this.getDefaultScaleValue(minValue, maxValue);
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('.rs-slider')
      .slider('value', defaultValue);
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.smiley-rs-icon')
      .addClass('unselected')
      .removeClass('selected');
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('.ui-slider-range')
      .css('opacity', '0');
    $(event.target).closest('.rating-scale-cont').find('.rs-slider').addClass('inactive-scale');
    $(event.target).closest('.rating-scale-cont').find('.show-rs-val').removeClass('show-rs-val');
    $(event.target).closest('.rating-scale-cont').find('.rs-clear-inp').val('');
    if ($(event.target).closest('.rating-scale-cont').find('.na-checkbox').length > 0) {
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.na-checkbox input[type="checkbox"]')
        .prop('checked', false);
      this.questions.isNA = false;
      this.isNA = false;
      this.SelectedValue(this.questions.Answers[Answers.length - 1], false, false);
    }

    this.SelectedValue(null, null);

    $(event.target).closest('.rating-scale-cont').find('.rs-clear-text').addClass('disabled');
    $(event.target).closest('.rating-scale-cont').find('.rs-clear-text-cont').addClass('disabled1');

    this.questions.isValid = false;
    // ADA
    this.clearRuntimeADAProperties(event.target);

    let labelCount = $(event.target).closest('.rating-scale-cont').find('.rs-slider-axis-val');
    if (labelCount.length % 2 == 0) {
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.slider-value-text')
        .css(
          'width',
          $(event.target).closest('.rating-scale-cont').find('.rs-wrapper').width() * 0.45 + 'px',
        );
    } else {
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.slider-value-text')
        .css(
          'width',
          $(event.target).closest('.rating-scale-cont').find('.rs-wrapper').width() * 0.3 + 'px',
        );
    }

    $(event.target).closest('.rating-scale-cont').find('.slider-value-text').hide();

    $(event.target).closest('.rating-scale-cont').find('.slider-value-text.rs-top-val').show();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setRsScale(event: Event) {
    this.isAnsChange = true;
    $(event.target).closest('.sl_input').removeClass('showRSValues');
    let minValue = $(event.target)
      .closest('.answer-option-wrapper')
      .find('.rs-slider-axis-val')
      .first()
      .attr('weight');
    let maxValue = $(event.target)
      .closest('.answer-option-wrapper')
      .find('.rs-slider-axis-val')
      .last()
      .attr('weight');
    let defaultValue = this.getDefaultScaleValue(minValue, maxValue);
    if ($(event.target).val() == '') {
      $(event.target)
        .closest('.answer-option-wrapper')
        .find('.rs-slider')
        .slider('value', defaultValue);
      $(event.target).val('');
      this.clearNA();
      this.SelectedValue(null, false);
      this.questions.isValid = false;
      $(event.target).closest('.answer-option-wrapper').find('.rs-clear-text').addClass('disabled');
      $(event.target)
        .closest('.answer-option-wrapper')
        .find('.rs-clear-text-cont')
        .addClass('disabled1');
      this.clearRuntimeADAProperties(event);
      this.disableSlider(event.target);
      $(event.target).closest('.rating-scale-cont').find('.slider-value-text.rs-top-val').show();
      return;
    }

    if ($(event.target).closest('.rs-mobile-cont').length > 0) {
      this.setMobileInputRS(event, defaultValue);
    } else {
      this.setInputRS(event, defaultValue);
    }
  }

  clearSmileyRating(event: Event) {
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('.ui-slider-range')
      .css('opacity', '0');
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-smiley-slider')
      .addClass('inactive-scale');
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.smiley-rs-icon')
      .addClass('unselected')
      .removeClass('selected');
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('input[type="radio"]')
      .prop('checked', false);

    let minValue = parseInt(
      $(event.target)
        .parents('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .first()
        .attr('weight')
        .trim(),
    );
    let maxValue = parseInt(
      $(event.target)
        .parents('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .last()
        .attr('weight')
        .trim(),
    );
    let defaultValue = this.getDefaultScaleValue(minValue, maxValue);
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('.rs-smiley-slider')
      .slider('value', defaultValue);
    $(event.target).closest('.rating-scale-cont').find('.show-rs-val').removeClass('show-rs-val');

    $(event.target).closest('.rating-scale-cont').find('.rs-wrapper').removeAttr('data-state');

    if (this.isRTLScale) {
      if (this.isReverseScale) {
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .attr('data-state', maxValue + '_' + maxValue);
      } else {
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .attr('data-state', minValue + '_' + maxValue);
      }
    } else {
      if (this.isReverseScale) {
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .attr('data-state', minValue + '_' + minValue);
      } else {
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .attr('data-state', maxValue + '_' + minValue);
      }
    }

    this.SelectedValue(null, false);

    $(event.target).closest('.rating-scale-cont').find('.rs-clear-text').addClass('disabled');
    $(event.target).closest('.rating-scale-cont').find('.rs-clear-text-cont').addClass('disabled1');

    // ADA
    this.clearRuntimeADAProperties(event.target);

    $(event.target)
      .closest('.rating-scale-cont')
      .find('.slider-value-text')
      .each(function (i) {
        $(this).css(
          'width',
          $(event.target).closest('.rating-scale-cont').find('.rs-smiley-parent').width() * 0.25 +
            'px',
        );
      });

    $(event.target).closest('.rating-scale-cont').find('.rs-slider-axis-val').hide();
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-slider-axis-val.visible-label-text')
      .show();
  }

  clearMobileRatingScale(event: Event) {
    this.isAnsChange = true;
    $(event.target).closest('.rs-mobile-cont').find('.sl_input').removeClass('showRSValues');
    $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper .rs-slider-axis-val')
      .css('display', 'none');
    $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper .rs-end-values-cont')
      .css('visibility', 'visible');
    $(event.target).closest('.rs-mobile-cont').find('.rs-clear-inp').val('');
    if ($(event.target).closest('.rs-mobile-cont').find('.na-checkbox').length > 0) {
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.na-checkbox input[type="checkbox"]')
        .prop('checked', false);
      this.questions.isNA = false;
      this.isNA = false;
      this.SelectedValue(this.questions.Answers[this.questions.Answers.length - 1], false, false);
    }
    var startVal = parseInt(
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-slider-axis-val')
        .first()
        .eq(0)
        .attr('weight'),
    );
    var endVal = parseInt(
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-slider-axis-val')
        .last()
        .attr('weight'),
    );
    var defaultValue = this.getDefaultScaleValue(startVal, endVal);
    $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper')
      .find('.rs-slider')
      .slider('value', defaultValue);

    this.SelectedValue(null, false);

    $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text').addClass('disabled');
    $(event.target).closest('.rs-mobile-cont').find('.rs-clear-text-cont').addClass('disabled1');

    this.questions.isValid = false;
    // ADA
    this.clearRuntimeADAProperties(event.target);
  }

  unselectCesCsat(obj, event: Event) {
    if ($(obj).closest('.ces-csat-ans-option').find('input[type="radio"]').prop('checked')) {
      event.preventDefault();
      this.SelectedValue(null, false);
      $(obj).closest('.ces-csat-ans-option').find('input[type="radio"]').prop('checked', false);
    }
  }

  unselectNps(obj, event: Event) {
    if (!$(obj).closest('.nps-ans-option-first').find('input[type="radio"]').prop('checked')) {
      $(obj).closest('.nps-box').find('.nps-axis-text-first').css('font-weight', 'bold');
    } else {
      $(obj).closest('.nps-box').find('.nps-axis-text-first').css('font-weight', 'normal');
    }
    if (!$(obj).closest('.nps-ans-option-last').find('input[type="radio"]').prop('checked')) {
      $(obj).closest('.nps-box').find('.nps-axis-text-last').css('font-weight', 'bold');
    } else {
      $(obj).closest('.nps-box').find('.nps-axis-text-last').css('font-weight', 'normal');
    }
    if ($(obj).closest('.nps-ans-option').find('input[type="radio"]').prop('checked')) {
      event.preventDefault();
      this.SelectedValue(null, false);
      $(obj).closest('.nps-ans-option').find('input[type="radio"]').prop('checked', false);
      if (
        $(obj).closest('.nps-wrapper').find('.nps-ans-option').find('input[type="radio"]:checked')
          .length > 0
      ) {
        $(obj).closest('.nps-wrapper').addClass('selected');
      } else {
        $(obj).closest('.nps-wrapper').removeClass('selected');
      }
    }
  }

  selectUnSelectNPS(obj) {
    if (
      $(obj).closest('.nps-wrapper').find('.nps-ans-option').find('input[type="radio"]:checked')
        .length > 0
    ) {
      $(obj).closest('.nps-wrapper').addClass('selected');
    } else {
      $(obj).closest('.nps-wrapper').removeClass('selected');
    }
  }

  getDefaultScaleValue(minValue: any, maxValue: any): number {
    // Not RTL + Reverse Scale Start -12
    if (!this.isRTLScale && this.isReverseScale) {
      return -minValue;
    }
    // RTL + Not Reverse Scale Start -1
    else if (this.isRTLScale && !this.isReverseScale) {
      return -maxValue;
    }
    // RTL + Reverse Scale Start 12
    else if (this.isRTLScale && this.isReverseScale) {
      return maxValue;
    }
    // Normal Scale Start 1
    else {
      return minValue;
    }
  }

  setADAProperties(sliderHandle: any) {
    let minSliderValue = $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.rs-slider-axis-wrapper .rs-slider-axis-val input:first-child')
      .attr('weight');
    let maxSliderValue = $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.rs-slider-axis-wrapper .rs-slider-axis-val input:last-child')
      .attr('weight');
    $(sliderHandle).find('.ui-slider-handle').attr('role', 'slider');
    if (this.isRTLScale) {
      $(sliderHandle).find('.ui-slider-handle').attr('aria-valuemin', maxSliderValue);
      $(sliderHandle).find('.ui-slider-handle').attr('aria-valuemax', minSliderValue);
    } else {
      $(sliderHandle).find('.ui-slider-handle').attr('aria-valuemin', minSliderValue);
      $(sliderHandle).find('.ui-slider-handle').attr('aria-valuemax', maxSliderValue);
    }
    $(sliderHandle)
      .find('.ui-slider-handle')
      .attr('aria-labelledby', `lbltitle_RS${this.questions.UniqueNumber}`);
  }

  setRuntimeADAProperties(sliderHandle: any, sliderVal: any) {
    let labelValue = $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find(`.rs-slider-axis-wrapper label[weight="${sliderVal}"] input`)
      .attr('weight');
    $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.ui-slider-handle')
      .attr('aria-valuenow', labelValue);
    let labelText = $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find(`.rs-slider-axis-wrapper label[weight="${sliderVal}"] .slider-value-text`)
      .text();
    $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.ui-slider-handle')
      .attr('aria-valuetext', labelText);
  }

  clearRuntimeADAProperties(sliderHandle: any) {
    $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.ui-slider-handle')
      .attr('aria-valuenow', '');
    $(sliderHandle)
      .closest('.answer-option-wrapper')
      .find('.ui-slider-handle')
      .attr('aria-valuetext', 'Unselected');
  }

  setSliderMinMaxValue() {
    if (this.questions.Answers[this.questions.Answers.length - 1].isNA) {
      this.sliderMinValue = this.questions.Answers[0].weight;
      this.sliderMaxValue = this.questions.Answers[this.questions.Answers.length - 2].weight;
    } else {
      this.sliderMinValue = this.questions.Answers[0].weight;
      this.sliderMaxValue = this.questions.Answers[this.questions.Answers.length - 1].weight;
    }
  }

  setMobileInputRS(event, defaultValue: number, isDD_value: boolean = false) {
    var startVal = parseInt(
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-slider-axis-val')
        .eq(0)
        .find('.rs-weight')
        .text()
        .trim(),
    );
    var scaleLength = $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper .rs-slider-axis-val').length;
    var endVal = parseInt(
      $(event.target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-slider-axis-val')
        .eq(scaleLength - 1)
        .find('.rs-weight')
        .text()
        .trim(),
    );

    var enteredVal;
    if (isDD_value) {
      enteredVal = defaultValue;
    } else {
      enteredVal = parseInt($(event.target).val());
    }

    $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper .rs-slider-axis-val')
      .css('display', 'none');
    $(event.target)
      .closest('.rs-mobile-cont')
      .find('.rs-mobile-wrapper .rs-end-values-cont')
      .css('visibility', 'hidden');

    var sliderVal: number;

    if ((this.isReverseScale && !this.isRTLScale) || (!this.isReverseScale && this.isRTLScale)) {
      if (enteredVal >= endVal && enteredVal <= startVal) {
        sliderVal = enteredVal - endVal + 1;
        this.SetDataValue(sliderVal, true);

        $(event.target)
          .closest('.rs-mobile-cont')
          .find('.rs-mobile-wrapper')
          .find('.rs-slider')
          .slider('value', -sliderVal);
        $(event.target)
          .closest('.rs-mobile-cont')
          .find(`.rs-mobile-wrapper .rs-slider-axis-val[weight='${sliderVal}']`)
          .css('display', 'inline');

        this.questions.isValid = false;
        this.enableSlider(event);
        this.setRuntimeADAProperties(event.target, sliderVal);
        if (!isDD_value) {
          this.nextQuestion(event.target);
        }
      } else {
        sliderVal = defaultValue;
        this.SelectedValue(null, false);
        this.service.rsInputValue = enteredVal;
        $(event.target)
          .closest('.rs-mobile-cont')
          .find('.rs-mobile-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');
        this.clearNA();
        this.questions.isValid = true;
        this.disableSlider(event.target);
        this.clearRuntimeADAProperties(event);
      }
    } else {
      if (enteredVal >= startVal && enteredVal <= endVal) {
        sliderVal = enteredVal - startVal + 1;
        this.SetDataValue(sliderVal, true);

        $(event.target)
          .closest('.rs-mobile-cont')
          .find('.rs-mobile-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.rs-mobile-cont')
          .find(`.rs-mobile-wrapper .rs-slider-axis-val[weight='${sliderVal}']`)
          .css('display', 'inline');

        this.questions.isValid = false;
        this.enableSlider(event);
        this.setRuntimeADAProperties(event.target, sliderVal);
        if (!isDD_value) {
          this.nextQuestion(event.target);
        }
      } else {
        sliderVal = defaultValue;
        this.SelectedValue(null, false);
        this.service.rsInputValue = enteredVal;
        $(event.target)
          .closest('.rs-mobile-cont')
          .find('.rs-mobile-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');
        this.clearNA();
        this.questions.isValid = true;
        this.disableSlider(event.target);
        this.clearRuntimeADAProperties(event);
      }
    }
  }

setInputRS(event, defaultValue: number) {
    var startVal = parseInt(
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.rs-wrapper .rs-slider-axis-val')
        .eq(0)
        .text()
        .trim(),
    );
    var scaleLength = $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper .rs-slider-axis-val').length;
    var endVal = parseInt(
      $(event.target)
        .closest('.rating-scale-cont')
        .find('.rs-wrapper .rs-slider-axis-val')
        .eq(scaleLength - 1)
        .text()
        .trim(),
    );
    var enteredVal = parseInt($(event.target).val());

    $(event.target)
      .closest('.rating-scale-cont')
      .find('.rs-wrapper')
      .find('.slider-value-text')
      .removeClass('show-rs-val');

    var sliderVal: number;

    if ((this.isReverseScale && !this.isRTLScale) || (!this.isReverseScale && this.isRTLScale)) {
      if (enteredVal >= endVal && enteredVal <= startVal) {
        sliderVal = enteredVal - endVal + 1;
        this.SetDataValue(sliderVal, event);

        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .find('.rs-slider')
          .slider('value', -sliderVal);
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper .slider-value-text')
          .eq(scaleLength - sliderVal)
          .addClass('show-rs-val')
          .show();
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.slider-value-text')
          .removeClass('tooltip-info');
        if (
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-wrapper .slider-value-text')
            .eq(scaleLength - sliderVal)
            .find('span')
            .text().length > 0
        ) {
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-wrapper .slider-value-text.show-rs-val')
            .addClass('tooltip-info');
        }
        $(event.target).closest('.rating-scale-cont').find('.slider-value-text.rs-top-val').hide();
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.slider-value-text.tooltip-info')
          .show();
        this.questions.isValid = false;
        this.enableSlider(event);
        this.setRuntimeADAProperties(event.target, sliderVal);
        this.nextQuestion(event.target);
      } else {
        sliderVal = defaultValue;
        this.SelectedValue(null, false);
        this.service.rsInputValue = enteredVal;
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');
        this.clearNA();
        this.questions.isValid = true;
        this.disableSlider(event.target);
        this.clearRuntimeADAProperties(event);
      }
    } else {
      if (enteredVal >= startVal && enteredVal <= endVal) {
        sliderVal = enteredVal - startVal + 1;
        this.SetDataValue(sliderVal, event);

        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper .slider-value-text')
          .eq(sliderVal - 1)
          .addClass('show-rs-val')
          .show();
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.slider-value-text')
          .removeClass('tooltip-info');
        if (
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-wrapper .slider-value-text')
            .eq(sliderVal - 1)
            .find('span')
            .text().length > 0
        ) {
          $(event.target)
            .closest('.rating-scale-cont')
            .find('.rs-wrapper .slider-value-text.show-rs-val')
            .addClass('tooltip-info');
        }
        $(event.target).closest('.rating-scale-cont').find('.slider-value-text.rs-top-val').hide();
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.slider-value-text.tooltip-info')
          .show();
        this.questions.isValid = false;
        this.enableSlider(event);
        this.setRuntimeADAProperties(event.target, sliderVal);
        this.nextQuestion(event.target);
      } else {
        sliderVal = defaultValue;
        this.SelectedValue(null, false);
        this.service.rsInputValue = enteredVal;
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.rs-wrapper')
          .find('.rs-slider')
          .slider('value', sliderVal);
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text')
          .removeClass('disabled');
        $(event.target)
          .closest('.answer-option-wrapper')
          .find('.rs-clear-text-cont')
          .removeClass('disabled1');
        this.clearNA();
        this.questions.isValid = true;
        this.disableSlider(event.target);
        this.clearRuntimeADAProperties(event);
      }
    }
    $(event.target)
      .closest('.rating-scale-cont')
      .find('.slider-value-text.show-rs-val.tooltip-info')
      .css(
        'width',
        $(event.target)
          .closest('.rating-scale-cont')
          .find('.slider-value-text.show-rs-val.tooltip-info span')
          .text().length *
          10 +
          10 +
          'px',
      );
  }

  enableSlider(event) {
    $(event.target).closest('.answer-option-wrapper').find('.ui-slider-range').css('opacity', '1');
    $(event.target)
      .closest('.answer-option-wrapper')
      .find('.rs-slider')
      .removeClass('inactive-scale');
    $(event.target)
      .closest('.answer-option-wrapper')
      .find('.rs-clear-text')
      .removeClass('disabled');
    $(event.target)
      .closest('.answer-option-wrapper')
      .find('.rs-clear-text-cont')
      .removeClass('disabled1');
  }

  disableSlider(target) {
    if (this.isMobile) {
      $(target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-slider-axis-val')
        .css('display', 'none');
      $(target)
        .closest('.rs-mobile-cont')
        .find('.rs-mobile-wrapper .rs-end-values-cont')
        .css('visibility', 'visible');
    } else {
      $(target).closest('.answer-option-wrapper').find('.ui-slider-range').css('opacity', '0');
      $(target).closest('.answer-option-wrapper').find('.rs-slider').addClass('inactive-scale');
      $(target).closest('.answer-option-wrapper').find('.show-rs-val').removeClass('show-rs-val');
    }
  }

  clearNA() {
    if (this.isNA) {
      this.isNA = false;
      this.questions.isNA = false;
    }
  }

  nextQuestion(event) {
    if (
      this.isNewParticipation &&
      (this.surveyFormat == 1 || this.surveyFormat == 2) &&
      (this.questions.ansConstraint == null || this.questions.isMatrixQuestion) &&
      this.service.isAutoScroll
    ) {
      let self = this;
      setTimeout(() => {
        let scrollTargetElement = $('#bodyScroll');
        const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
        if (self.questions.selectAnsValue != 0) {
          if (
            self.questions.qtype == 'SR' ||
            self.questions.qtype == 'GR' ||
            self.questions.qtype == 'RG' ||
            self.questions.qtype == 'RW'
          ) {
            var nextbtnLength = $(event)
              .closest('.active-ques')
              .nextAll('.inactive-ques')
              .has('.question-data').length;
            var nextbtnLength1 = $(event)
              .closest('.inactive-ques')
              .nextAll('.active-ques')
              .has('.question-data').length;
            var elemPosition;
            elemPosition = $(event)
              .closest('.matrix-standalone-active-ques' + self.questions.group_no)
              .nextAll('.matrix-standalone-active-ques' + self.questions.group_no);
            var MatrixelemPosition;
            MatrixelemPosition = $(event)
              .closest('.matrix-mobile-subQ_' + self.group.Matrix_id)
              .nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id);
            var MatrixelemPosition1 = $(event)
              .closest('.matrix-mobile-subQ-cont')
              .nextAll('.matrix-mobile-subQ-cont');

            if (elemPosition.length > 0) {
              elemPosition = $(event)
                .closest('.matrix-standalone-active-ques' + self.questions.group_no)
                .nextAll('.matrix-standalone-active-ques' + self.questions.group_no)
                .has('.question-data')
                .eq(0)
                .offset().top;
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop() -
                    $('.toolbar').innerHeight();
                } else {
                  scrollTargetElement = $('.app-participation');
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop();
                }
              } else {
                elemPosition =
                  elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
              scrollTargetElement.animate(
                {
                  scrollTop: elemPosition - $(window).height() / 3,
                },
                400,
              );
            } else if (MatrixelemPosition.length > 0) {
              MatrixelemPosition = $(event)
                .closest('.matrix-mobile-subQ_' + self.group.Matrix_id)
                .nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
                .has('.question-data')
                .eq(0)
                .offset().top;
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  MatrixelemPosition =
                    MatrixelemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop() -
                    $('.toolbar').innerHeight();
                } else {
                  scrollTargetElement = $('.app-participation');
                  MatrixelemPosition =
                    MatrixelemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop();
                }
              } else {
                MatrixelemPosition =
                  MatrixelemPosition -
                  scrollTargetElement.offset().top +
                  scrollTargetElement.scrollTop();
              }
              scrollTargetElement.animate(
                {
                  scrollTop: MatrixelemPosition - $(window).height() / 3,
                },
                400,
              );
            } else if (MatrixelemPosition1.length > 0) {
              MatrixelemPosition1 = $(event)
                .closest('.matrix-mobile-subQ-cont')
                .nextAll('.matrix-mobile-subQ-cont')
                .has('.question-data')
                .eq(0)
                .offset().top;
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  MatrixelemPosition1 =
                    MatrixelemPosition1 -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop() -
                    $('.toolbar').innerHeight();
                } else {
                  scrollTargetElement = $('.app-participation');
                  MatrixelemPosition1 =
                    MatrixelemPosition1 -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop();
                }
              } else {
                MatrixelemPosition1 =
                  MatrixelemPosition1 -
                  scrollTargetElement.offset().top +
                  scrollTargetElement.scrollTop();
              }
              scrollTargetElement.animate(
                {
                  scrollTop: MatrixelemPosition1 - $(window).height() / 3,
                },
                400,
              );
            } else if (nextbtnLength > 0) {
              elemPosition = $(event)
                .closest('.active-ques')
                .nextAll('.inactive-ques')
                .has('.question-data')
                .eq(0)
                .offset().top;
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop() -
                    $('.toolbar').innerHeight();
                } else {
                  scrollTargetElement = $('.app-participation');
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop();
                }
              } else {
                elemPosition =
                  elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
              scrollTargetElement.animate(
                {
                  scrollTop: elemPosition - $(window).height() / 3,
                },
                400,
              );
            } else if (nextbtnLength1 > 0) {
              elemPosition = $(event)
                .closest('.inactive-ques')
                .nextAll('.active-ques')
                .has('.question-data')
                .eq(0)
                .offset().top;
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop() -
                    $('.toolbar').innerHeight();
                } else {
                  scrollTargetElement = $('.app-participation');
                  elemPosition =
                    elemPosition -
                    scrollTargetElement.offset().top +
                    scrollTargetElement.scrollTop();
                }
              } else {
                elemPosition =
                  elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
              scrollTargetElement.animate(
                {
                  scrollTop: elemPosition - $(window).height() / 3,
                },
                400,
              );
            } else {
              if (checkIfPrevirew && checkIfPrevirew != '') {
                if (this.service.preview.viewport === 'web') {
                  scrollTargetElement = $('#bodyScroll');
                } else {
                  scrollTargetElement = $('.app-participation');
                }
              }
              var scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();

              scrollTargetElement.animate(
                {
                  scrollTop: scrollVal,
                },
                400,
              );
            }
          } else {
            if (
              !(
                ((self.questions.qtype == 'RW' || self.questions.qtype == 'RG') &&
                  self.questions.qsubtype == 1) ||
                ((self.questions.qtype == 'GR' || self.questions.qtype == 'SR') &&
                  self.questions.qsubtype == 0)
              )
            ) {
              this.service.gotoNextQuestion(this.questions, event);
            }
          }
        } else {
          $(event).closest('.main-ques-cont').find('.ques-response-btn').show();
        }
      }, 1);
    } else if (this.surveyFormat == 3) {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find('.question-data').attr('hidden');

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    let scrollTargetElement = $('#bodyScroll');
    const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
    if (this.questions.group_no != 0) {
      var nextbtnLength = $(event)
        .closest('.active-ques')
        .nextAll('.inactive-ques')
        .has('.question-data').length;

      var elemPosition;
      elemPosition = $(event)
        .closest('.matrix-standalone-active-ques' + question.group_no)
        .nextAll('.matrix-standalone-active-ques' + question.group_no);

      var MatrixelemPosition;
      MatrixelemPosition = $(event)
        .closest('.matrix-mobile-subQ_' + this.group.Matrix_id)
        .nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id);
      //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id)
      var MatrixelemPosition1 = $(event)
        .closest('.matrix-mobile-subQ-cont')
        .nextAll('.matrix-mobile-subQ-cont');
      if (elemPosition.length > 0) {
        elemPosition = $(event)
          .closest('.matrix-standalone-active-ques' + question.group_no)
          .nextAll('.matrix-standalone-active-ques' + question.group_no)
          .has('.question-data')
          .eq(0)
          .offset().top;
        if (checkIfPrevirew && checkIfPrevirew != '') {
          if (this.service.preview.viewport === 'web') {
            elemPosition =
              elemPosition -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop() -
              $('.toolbar').innerHeight();
          } else {
            scrollTargetElement = $('.app-participation');
            elemPosition =
              elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
        } else {
          elemPosition =
            elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        scrollTargetElement.animate(
          {
            scrollTop: elemPosition - $(window).height() / 3,
          },
          400,
        );
      } else if (MatrixelemPosition.length > 0) {
        MatrixelemPosition = $(event)
          .closest('.matrix-mobile-subQ_' + this.group.Matrix_id)
          .nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
          .has('.question-data')
          .eq(0)
          .offset().top;
        if (checkIfPrevirew && checkIfPrevirew != '') {
          if (this.service.preview.viewport === 'web') {
            MatrixelemPosition =
              MatrixelemPosition -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop() -
              $('.toolbar').innerHeight();
          } else {
            scrollTargetElement = $('.app-participation');
            MatrixelemPosition =
              MatrixelemPosition -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop();
          }
        } else {
          MatrixelemPosition =
            MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        scrollTargetElement.animate(
          {
            scrollTop: MatrixelemPosition - $(window).height() / 3,
          },
          400,
        );
      } else if (MatrixelemPosition1.length > 0) {
        MatrixelemPosition1 = $(event)
          .closest('.matrix-mobile-subQ-cont')
          .nextAll('.matrix-mobile-subQ-cont')
          .has('.question-data')
          .eq(0)
          .offset().top;
        if (checkIfPrevirew && checkIfPrevirew != '') {
          if (this.service.preview.viewport === 'web') {
            MatrixelemPosition1 =
              MatrixelemPosition1 -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop() -
              $('.toolbar').innerHeight();
          } else {
            scrollTargetElement = $('.app-participation');
            MatrixelemPosition1 =
              MatrixelemPosition1 -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop();
          }
        } else {
          MatrixelemPosition1 =
            MatrixelemPosition1 -
            scrollTargetElement.offset().top +
            scrollTargetElement.scrollTop();
        }
        scrollTargetElement.animate(
          {
            scrollTop: MatrixelemPosition1 - $(window).height() / 3,
          },
          400,
        );
      } else if (nextbtnLength > 0) {
        elemPosition = $(event)
          .closest('.active-ques')
          .nextAll('.inactive-ques')
          .has('.question-data')
          .eq(0)
          .offset().top;
        if (checkIfPrevirew && checkIfPrevirew != '') {
          if (this.service.preview.viewport === 'web') {
            elemPosition =
              elemPosition -
              scrollTargetElement.offset().top +
              scrollTargetElement.scrollTop() -
              $('.toolbar').innerHeight();
          } else {
            scrollTargetElement = $('.app-participation');
            elemPosition =
              elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
        } else {
          elemPosition =
            elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        scrollTargetElement.animate(
          {
            scrollTop: elemPosition - $(window).height() / 3,
          },
          400,
        );
      } else {
        if (checkIfPrevirew && checkIfPrevirew != '') {
          if (this.service.preview.viewport === 'web') {
            scrollTargetElement = $('#bodyScroll');
          } else {
            scrollTargetElement = $('.app-participation');
          }
        }
        let scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();

        scrollTargetElement.animate(
          {
            scrollTop: scrollVal,
          },
          400,
        );
      }
    } else if (!question.isValid) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  stopEnter(event) {
    event.stopPropagation();
    return false;
  }

  resetScale() {
    let id: string = '#Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_RS';
    if (this.questions.RSFormat == 0) {
      // id is already set to default value
    } else if (this.questions.RSFormat == 1) {
      if (this.isMobile) {
        // id is already set to default value
      } else {
        id = '#Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_RS_Smiley';
      }

      $(id).closest('.answer-option-wrapper').find('.rs-smiley-slider').addClass('inactive-scale');
      $(id)
        .closest('.answer-option-wrapper')
        .find('.smiley-rs-icon')
        .addClass('unselected')
        .removeClass('selected');
      let minValue1 = parseInt(
        $(id)
          .closest('.answer-option-wrapper')
          .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
          .first()
          .attr('weight')
          .trim(),
      );
      let maxValue1 = parseInt(
        $(id)
          .closest('.answer-option-wrapper')
          .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
          .last()
          .attr('weight')
          .trim(),
      );
      let self = this;
      if (self.isRTLScale) {
        if (self.isReverseScale) {
          $(id)
            .closest('.rs-smiley-wrapper')
            .attr('data-state', maxValue1 + '_' + maxValue1);
        } else {
          $(id)
            .closest('.rs-smiley-wrapper')
            .attr('data-state', minValue1 + '_' + maxValue1);
        }
      } else {
        if (self.isReverseScale) {
          $(id)
            .closest('.rs-smiley-wrapper')
            .attr('data-state', minValue1 + '_' + minValue1);
        } else {
          $(id)
            .closest('.rs-smiley-wrapper')
            .attr('data-state', maxValue1 + '_' + minValue1);
        }
      }

      $(id).closest('.rating-scale-cont').find('.rs-slider-axis-val').hide();
      $(id).closest('.rating-scale-cont').find('.rs-slider-axis-val.visible-label-text').show();
    }

    $(id).find('.ui-slider-range').css('opacity', '0');
    $('.na-checkbox input').prop('checked', false);
    this.isNA = false;

    $(id).closest('.rs-mobile-wrapper').find('.rs-slider-axis-val').hide();
    $(id).closest('.rs-mobile-wrapper').find('.rs-end-values-cont').css('visibility', 'visible');
    $(id).closest('.answer-option-wrapper').find('.ui-slider-handle').attr('aria-valuenow', '');
    $(id)
      .closest('.answer-option-wrapper')
      .find('.ui-slider-handle')
      .attr('aria-valuetext', 'Unselected');

    let minValue = parseInt(
      $(id)
        .closest('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .first()
        .attr('weight')
        .trim(),
    );
    let maxValue = parseInt(
      $(id)
        .closest('.answer-option-wrapper')
        .find('.rs-slider-axis-wrapper .rs-slider-axis-val')
        .last()
        .attr('weight')
        .trim(),
    );

    let defaultValue = this.getDefaultScaleValue(minValue, maxValue);
    $(id).slider('value', defaultValue);
    $(id).closest('.answer-option-wrapper').find('.rs-clear-inp').val('');
    $(id).closest('.answer-option-wrapper').find('.rs-clear-text').addClass('disabled');
    $(id).closest('.answer-option-wrapper').find('.rs-clear-text-cont').addClass('disabled1');
    this.disableSlider(id);
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {
    if (answer.value_id == 1) {
      return this.group.L_text;
    } else if (this.group.M_Pos == parseInt(answer.value_text)) {
      return this.group.M_text;
    } else {
      let max = question.Answers.reduce((prev, current) =>
        prev.value_id > current.value_id ? prev : current,
      );
      if (max != null && max != undefined) {
        if (max.weight == 0) {
          if (answer.value_text == '') {
            return 'N/A';
          } else if (answer.value_text != null) {
            if (
              max.value_id - 1 == answer.value_id &&
              answer.weight != null &&
              answer.weight != 0
            ) {
              return this.group.H_text;
            } else if (answer.value_text != null && max.value_id == answer.value_id) {
              let value: any = answer.value_text;
              if (answer.value_text.indexOf('N/A') < 0) {
                answer.value_text = value + ' ' + 'N/A';
              }
              return answer.weight.toString();
            }
          }
        } else if (max.value_id == answer.value_id && answer.weight != 0) {
          return this.group.H_text;
        }
        return answer.weight.toString();
      }
    }
    return ''; // Default return value
  }

  answerSort(): Answers[] {
    return this.questions.Answers.sort((n1, n2) => n1.weight - n2.weight);
  }

  getQuestionState(question: Questions) {
    if (question.RS_Type == 2) {
      return question.Answers.length - 1;
    } else {
      return question.Answers.length;
    }
  }

  disableEnableSmiley(elem, isCheked: boolean, answer: Answers, event: Event) {
    if ($(elem).is(':checked')) {
      this.unselectCesCsat($(elem), event);
    }
    if (isCheked) {
      this.questions.isNA = true;
      this.isNA = true;
      answer.ControlAns = 'N/A';
      this.SelectedValue(answer, true, true);
    } else {
      this.questions.isNA = false;
      this.isNA = false;
      this.SelectedValue(answer, false, false);
    }
  }

  getCESCSATSmileyText(Answers: Answers[], i: number): string {
    if (this.questions.qtype == 'RG') {
      let answer = Answers[i];
      if (answer.value_id == 1) {
        return this.group.L_text;
      } else if (this.group.M_Pos == parseInt(answer.value_text)) {
        return this.group.M_text;
      } else {
        let max = this.questions.Answers.reduce((prev, current) =>
          prev.value_id > current.value_id ? prev : current,
        );
        if (max != null && max != undefined) {
          if (max.weight == 0) {
            if (answer.value_text == '') {
              return 'N/A';
            } else if (answer.value_text != null) {
              if (
                max.value_id - 1 == answer.value_id &&
                answer.weight != null &&
                answer.weight != 0
              ) {
                return this.group.H_text;
              } else if (answer.value_text != null && max.value_id == answer.value_id) {
                let value: any = answer.value_text;
                if (answer.value_text.indexOf('N/A') < 0) {
                  answer.value_text = value + ' ' + 'N/A';
                }
                return '';
              }
            }
          } else if (max.value_id == answer.value_id && answer.weight != 0) {
            return this.group.H_text;
          }
          return '';
        }
      }
    } else {
      return Answers[i].value_text;
    }
    return ''; // Default return value
  }

  getValueText(question: Questions, Item: Answers) {
    if (question) {
      if (question.RS_Type == 2) {
        if (Item.weight == 0 || Item.weight == 10) return Item.weight + ' - ' + Item.value_text;
        else return Item.weight;
      } else {
        return Item.value_text;
      }
    }
    return '';
  }

  GetAnswers(): Answers[] {
    if (this.questions.Answers[this.questions.Answers.length - 1].isNA) {
      let isNaAns = this.questions.Answers.find((e) => e.isNA);
      let curIndex = this.questions.Answers.indexOf(isNaAns);

      if (curIndex >= 0) {
        let cesCsatAns = this.questions.Answers.filter((e) => !e.isNA);
        return cesCsatAns;
      }
    }
    return this.questions.Answers;
  }

  isNAEnable(): boolean {
    return this.questions.Answers.filter((e) => e.isNA).length > 0;
  }
}
